
import { Component, EventEmitter, HostListener, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TimeOffService } from '@app/main/time-off/services/time-off.service';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { ModalPopupComponent } from '@app/shared/common/modal-popup/modal-popup/modal-popup.component';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { AppComponentBase } from '@shared/common/app-component-base';
import { UsersDateFormatService } from '@shared/common/dateTimeFormat/date-format.service';
import { ApprovalWindowInEnum, BlobHelperServiceProxy, ClientContactDto, ClientDto, ClientServiceProxy, ClientType2, ClientType3, ProfileServiceProxy, ProjectBillingType, ProjectClientApproversDto, ProjectCreateOrEditDto, ProjectGetAllDto, ProjectProductServiceCreateOrEditDto, ProjectServiceProxy, ProjectTeamCreateOrEditDto, ProjectTeamGetAllDto, ProjectTimeOffCreateOrEditDto, ProjectTimeSheetCreateEditDto, ProjectTimeSheetGetAllDto, StoreImageOnBlobDto, TenantProductServiceDto, TenantProductServiceGetAllDto, TenantProductServiceProxy, UserListDto, UserListRoleDto, UserServiceProxy, UpdateProjectTimesheetTimeLineDto } from '@shared/service-proxies/service-proxies';
import { AbpSessionService, MessageService } from 'abp-ng2-module';
import { DateTime } from 'luxon';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { LazyLoadEvent } from 'primeng/api';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProjectService } from '../Services/project.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { ApproverDetail } from '../shared/models/ApproverDetail.model';
import { ApproveProjectComponent } from './approve-project/approve-project.component';
import { ProjectImageUploadComponent } from './project-image-upload/project-image-upload.component';
import * as _ from "lodash";
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { BsDaterangepickerDirective } from 'ngx-bootstrap/datepicker';
import { ProjectTimeOffApprovalComponent } from './project-time-off-approval/project-time-off-approval.component';
import { AppConsts } from '@shared/AppConsts';
import { ProjectDocsUploadComponent } from '../shared/project-docs-upload/project-docs-upload.component';

@Component({
    standalone: false,
    selector: "app-add-new-project",
    templateUrl: "./add-new-project.component.html",
    styleUrls: ["./add-new-project.component.scss"],
})
export class AddNewProjectComponent extends AppComponentBase implements OnInit {
    readonly maxDailyHours = 24;

    @ViewChild("projectForm", { static: true }) projectForm: NgForm;
    @ViewChild("timesheetForm", { static: true }) timesheetForm: NgForm;
    @ViewChild('projectimgmodal', { static: true }) projectimgmodal: ProjectImageUploadComponent;
    @ViewChild("ApproveProjectTab", { static: true }) ApproveProjectComponent: ApproveProjectComponent;
    @ViewChild("appModalPopup") appModalPopup: ModalPopupComponent;
    @ViewChild("appChangeRouteModalPopup") appChangeRouteModalPopup: ModalPopupComponent;
    @ViewChild('dataRangePicker') dataRangePicker: BsDaterangepickerDirective;
    @ViewChild(ProjectTimeOffApprovalComponent) projectTimeOffApprovalComponentInstace: ProjectTimeOffApprovalComponent;
    @ViewChild(ProjectDocsUploadComponent) projectDocsUpload: ProjectDocsUploadComponent;

    @Output() userapproval = new EventEmitter<UserListDto[]>();
    @Input() projType: number;
    @Output() projectAdded: EventEmitter<void> = new EventEmitter<void>();
    project: ProjectCreateOrEditDto = new ProjectCreateOrEditDto();
    selectServiceRecord: TenantProductServiceGetAllDto[] = [];
    productServiceRecords: TenantProductServiceGetAllDto[] = [];
    selectedProductServiceRecords: TenantProductServiceGetAllDto[] = [];
    projectbillabityAccess:string = '2';
    updateProjectTimesheetTimeLineList: UpdateProjectTimesheetTimeLineDto[] = [];
    updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
    updateClientTimesheetTimeLineList: UpdateProjectTimesheetTimeLineDto[] = [];
    updateClientTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();

    @HostListener('window:beforeunload', ['$event'])
    showMessage($event) {
        $event.returnValue = 'Your data will be lost!';
    }

    listMember1: ProjectTeamGetAllDto[] = [];
    selectedTeamDropdown: ProjectTeamGetAllDto[] = [];
    userRecords: UserListDto[] = [];
    userRecords2: UserListDto[] = [];
    userRecords3: UserListDto[] = [];
    userRecords4: UserListDto[] = [];
    userRecords5: UserListDto[] = [];

    checkProjectDuplicate: boolean = false;
    isSidebarOpen: boolean;
    isSidePanel: boolean;
    level2disabled = true;
    level3disabled = true;
    level4disabled = true;
    addMoreLevel = true;
    HideProjTimeSheetChk = false;
    isLoading: boolean;
    name = "";
    clientFilter: "";
    projectId: number;
    editProject: ProjectGetAllDto;
    productServiceId: number;
    subHeaderText = "";
    subHeaderText1 = "";
    TimesheetApproverLevelShow: number = 0;
    endDate: Date;
    startdate: any;
    enddate: any;
    today: Date;
    /** Stable min for project start/end pickers (10 years back). */
    projectDateMin: Date;
    dateFormat = this.l("dd/MM/yyyy");
    bsDateFormat = this.l('DD/MM/YYYY');
    dateCustFormat = this.l("dd/MM/yyyy");
    startDateError: any = { isError: false, errorMessage: "" };
    endDateError: any = { isError: false, errorMessage: "" };
    diDate = 1;
    registerForm: FormGroup;
    submitted = false;
    filter = "";
    role = "";
    submitted1 = false;
    isDisabledEdit = true;
    buttonVisable: boolean;
    textVisible = false;
    isFormDisabled: boolean;
    option: number;
    isButtonVisible: boolean;
    isSaveVisible = true;
    projectType: number;
    serviceID: number;
    isNewProject: boolean;
    projectEditData: ProjectGetAllDto = new ProjectGetAllDto();
    create_edit_project: FormGroup;
    saving: boolean = false;
    showImg = true;
    showImgModal = false;
    imagePathModal = "";
    isShown = false;
    firstName = "";
    textName = "";
    LevelShow1 = true;
    LevelShow2 = false;
    LevelShow3 = false;
    LevelShow4 = false;
    LevelShow5 = false;
    visited = [0, 0, 0, 0];
    number = ["One", "Two", "Three", "Four",'Five'];
    projectDocsAccordionOpen = false;
    id: number;
    projectTy: ProjectBillingType;
    myEnum = typeof ProjectBillingType;
    taskInfoProject: ProjectBillingType[] = [];
    isLevelCount5: boolean = false;
    onlyLockedUsers = false;
    clientStyle = false;
    teamMemberStyle = false;
    flag: number;
    serviceProductFlagStyle = false;
    teamMemberFlagId: number;
    mangerSelecteShow = true;
    mangerSelecteShowService = true;
    isShow = true;
    showSecondApproval = true;
    deleteMemberList: any[] = [];
    selectedTeamMembers: ProjectTeamGetAllDto[];
    selectedMembers: UserListDto[] = [];

    timesheetApprovers: UserListDto[] = [null, null, null, null, null];
    selectedMembers1: UserListDto[] = [];
    selectedMembers2: UserListDto[] = [];
    selectedMembers3: UserListDto[] = [];
    selectedMembers4: UserListDto[] = [];
    selectedMembers5: UserListDto[] = [];

    tempAllMembersStore: UserListDto[] = [];
    listMember: ProjectTeamGetAllDto[] = [];
    clientsdata: ClientDto;
    clientsdatabinded: ClientDto;
    selectedClientContacts: ClientContactDto[] = [];
    clientContactDropdown: ProjectClientApproversDto[] = [];
    clientContactApprovers: ProjectClientApproversDto[] = [];
    clientApprovalWindow: number;
    clientApprovalWindowInEnum: ApprovalWindowInEnum = ApprovalWindowInEnum.Hours;
    usersData: UserListDto[] = [];
    allUsersData: UserListDto[] = [];
    ProgramManagerUsers: UserListDto[] = [];
    ProjectManagerUsers: UserListDto[] = [];
    allClients: ClientDto[] = [];
    serviceList: TenantProductServiceDto[] = [];
    deleteServiceList: TenantProductServiceGetAllDto[] = [];
    integrationSigleSelectedData = [];
    projectForEdit: ProjectGetAllDto;
    clientContactData: ClientContactDto = new ClientContactDto();
    primaryContactList: ClientContactDto[] = [];
    firstMemberList: any[] = [];
    secondMemberList: any[] = [];
    imagePath = "";
    taskTypeInfo = [];
    filterText = "";
    filterText1 = "";
    filterText2 = "";
    filterText3 = "";
    filterText4 = "";
    filterText5 = "";
    filterTextClientApproval = "";
    isCheckTimeSheetSettings = true;
    devProjectName: string;
    personalAccessToken: string;
    projectURL: string;

    programManager: UserListDto;
    projectManager: UserListDto[] = [];
    minDate = new Date();
    maxDate = new Date();
    projectType1: boolean = false;
    projectType2: boolean = false;
    dataSubmitted: boolean = false;
    projectTimeOffdata: ProjectTimeOffCreateOrEditDto;
    projDurationValid = true;
    projectTeamTotalWorkHrs: number = 0;
    routerSub: Subscription;
    navigationUrl: string;
    isSidePanelOpen: boolean;
    isDevProjectNameValid: boolean = true;
    isProjectURLValid: boolean = true;
    isPersonalAccessTokenValid: boolean = true;

    onDevProjectNameChange() {
        // Check if the input value is not empty
        this.isDevProjectNameValid = this.devProjectName.trim() !== '';
    }

    onProjectURLChange() {
        // Check if the input value is not empty
        this.isProjectURLValid = this.projectURL.trim() !== '';
    }

    onPersonalAccessTokenChange() {
        // Check if the input value is not empty
        this.isPersonalAccessTokenValid = this.personalAccessToken.trim() !== '';
    }

    AllProjectNames: string[] = []; //containing all active projects names
    endDateValid: boolean = false;
    timer: any

    //Timesheet Approvers Data for edit.
    approverDetailLevel1: ApproverDetail = new ApproverDetail();
    approverDetailLevel2: ApproverDetail = new ApproverDetail();
    approverDetailLevel3: ApproverDetail = new ApproverDetail();
    approverDetailLevel4: ApproverDetail = new ApproverDetail();
    approverDetailLevel5: ApproverDetail = new ApproverDetail();

    filteredUsers: UserListDto[] = []; // for timesheet timeoff approvers dropdown

    TimesheetFreqData = [
        { id: 0, name: this.l("None") },
        { id: 1, name: this.l("Bimonthly") },
        { id: 2, name: this.l("Monthly") },
        { id: 3, name: this.l("Weekly") },
        {id : 4, name :this.l("Daily")}
    ]

    WindowEnum = [
        { id: 1, name: this.l("Hours") },
        { id: 2, name: this.l("Days") }
    ]

    projectBillableTypes = [
        { id: 1, name: "Billable" },
        { id: 2, name: "Non-Billable" },
    ];
    projectBillableSelected: number;

    projectStatusInfo = [
        { id: 1, name: "New", icon: "assets/common/images/timetracking/New (1).svg" },
        { id: 2, name: "Active", icon: "assets/common/images/timetracking/Active (1).svg" },
        { id: 3, name: "Completed", icon: "assets/common/images/timetracking/Completed (1).svg" },
        { id: 4, name: "Closed", icon: "assets/common/images/timetracking/Removed (1).svg" },
    ];
    projectStatusSelected = 1;

    serviceDropdown = [
        { id: 0, name: "Single Hourly Rate", discription: "Use a single hourly rate for this" },
        { id: 1, name: "Team Member Rates", discription: "Use a single hourly rate for each team member" },
        { id: 2, name: "Service Rates", discription: "Use a single hourly rate for each team service" },
    ];
    integration = [
        {
            id: 4,
            icon: "assets/common/images/projects/azureDevOps.svg",
            name: "Azure DevOps",
            description: "Connect with Azure Devops for importing work items",
        },
    ];
    projectTimesheet: ProjectTimeSheetGetAllDto = new ProjectTimeSheetGetAllDto();
    tempDate: any;
    isTimesheetSubmitted: boolean = false;
    dateTime = new Date();
    msg: string;
    projectFormSubmitted: boolean = false;
    isOnlySpaceInString: boolean = false;

    constructor(
        private _abpSessionService: AbpSessionService,
        private _monitorService: MonitoringService,
        injector: Injector,
        private _router: Router,
        private _blobHelperServiceProxy: BlobHelperServiceProxy,
        private toastr: ToastrService,
        private _activatedRoute: ActivatedRoute,
        private _spinnerService: NgxSpinnerService,
        private _profileService: ProfileServiceProxy,
        private _userServiceProxy: UserServiceProxy,
        private _clientServiceProxy: ClientServiceProxy,
        private _tenantProductServiceProxy: TenantProductServiceProxy,
        private _projectServiceProxy: ProjectServiceProxy,
        private _usersDateFormatService: UsersDateFormatService,
        private headerTitleService: HeaderTitleService,
        private _messageService: MessageService,
        public timeOffService: TimeOffService,
        public projectService: ProjectService
    ) {
        super(injector);
    }
    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-AddNewProject");
        const x = this._activatedRoute.snapshot.queryParams.projectType;
        if (x) {
            this.project.projectType = x;
            this.projectType = Number(this._activatedRoute.snapshot.queryParams.projectType);
        } else {
            this.projectType = Number(history.state.projectType);
        }

        this.flag = null;
        //default value for timesheet drp downs
        this.defaultValuesForTimesheetDropdown();

        this.getAllClients();
        this.getUsers();
        this.getProjectServices();

        if (this.projType > 0) {
            this.setProjectType(this.projType);
        }
        this.option = Number(this._activatedRoute.snapshot.queryParams.option);
        this.option = Number(history.state.option);
        for (let taskTypeInfo in ProjectBillingType) {
            if (isNaN(Number(taskTypeInfo))) {
                this.taskTypeInfo.push(taskTypeInfo as string);
            }
        }
        this.projectId = Number(this._activatedRoute.snapshot.params['id']);
        this.getDateFormate();
        this.subHeaderText1 = this.l('ActiveProjects');
        this.subHeaderText = this.l('NewProject');
        this.setBreadCrumb();

        this.today = new Date();
        this.today.setHours(0, 0, 0, 0);
        this.maxDate = new Date(this.today);
        this.maxDate.setFullYear(this.maxDate.getFullYear() + 10);

        this.projectDateMin = new Date(this.today);
        this.projectDateMin.setFullYear(this.projectDateMin.getFullYear() - 10);
        this.minDate = new Date(this.projectDateMin);

    }

    get isCreateMode(): boolean {
        return !this.projectId;
    }

    getEndDateMin(): Date {
        if (this.startdate) {
            return this.startdate;
        }
        return this.minDate;
    }
    setBreadCrumb() {
        if (this.projectId > 0) {
            this.isFormDisabled = false;
            this.subHeaderText1 = this.l('ActiveProjects');
            this.subHeaderText = this.l('EditProject');
        }
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem(this.l('Projects')),
            new BreadcrumbItem(this.subHeaderText1),
            new BreadcrumbItem(this.subHeaderText)
        ]));
    }
    ngOnChanges() {
        this.setProjectType(this.projType);
    }

    canceledSaved: boolean = false;
    //For confirm leave form guard
    shouldConfirmBeforeLeavingComponent() {
        return !this.canceledSaved;
    }

    //For confirm leave form guard
    changeRoute: any;
    changeRouteResolve: any;
    changeRouteReject: any;
    async showChangeRouteModal() {
        var component = this;

        return new Promise<boolean>((resolve, reject) => {
            this.spinnerService.hide();
            this.appChangeRouteModalPopup.show(2);

            component.changeRouteResolve = resolve;
            component.changeRouteReject = reject;
        });
    }

    changeRouteModalYes(event) {
        this.changeRouteResolve(true);
    }

    changeRouteModalCancel() {
        this.changeRouteResolve(false);
    }

    onlyNumberKey(event) {
        return event.charCode === 8 || event.charCode === 0 ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    getStartdate(e: DateTime) {
        if (e) {
            this.startdate = new Date(e.toString());
            this.minDate = this.startdate;
            if ((this.startdate > this.enddate) && this.startdate && this.enddate) {
                this.startDateError = { isError: true, errorMessage: "End date must be greater than start date!" };
                this.startdate = new Date(this.enddate.getTime() - 86400000);
                this.minDate = this.startdate;
                return;
            }
            // Keep teammate-specific dates. Only pull a member back inside the project window.
            this.clampMemberDatesToProjectRange();
            this.updateProjectHoursValidation();
        }
    }

    getEnddate(e: DateTime) {
        if (e) {
            this.enddate = new Date(e.toString());
            this.maxDate = this.enddate;
            if (this.enddate.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0) && this.projectStatusSelected == 3) this.projectStatusSelected = 2;
            if (this.startdate !== "" && this.startdate !== undefined && this.enddate < this.startdate) {
                this.enddate = new Date(this.startdate.getTime() + 86400000);
                return;
            }
            this.dateCustFormat = this.dateFormat;
            if (this.startdate !== "" && this.startdate !== undefined && this.enddate < this.startdate) {
                this.endDateError = { isError: true, errorMessage: "End date must be greater than start date!" };
            } else if (this.startdate !== "" && this.startdate !== undefined && this.enddate > this.startdate) {
                this.endDateError = { isError: false, errorMessage: "" };
            } else if (this.startdate !== undefined && this.startdate !== "" && this.enddate !== "" && this.enddate !== undefined) {
            }

            if (this.startdate > this.enddate) {
                this.enddate = null;
                this.endDateValid = true;

            }
            else {
                this.endDateValid = false;
            }

            // Keep teammate-specific dates. Only pull a member back inside the project window.
            this.clampMemberDatesToProjectRange();
            this.updateProjectHoursValidation();
        }
    }

    private toDateOnly(value: Date | string | DateTime): Date {
        const date = new Date(value.toString());
        date.setHours(0, 0, 0, 0);
        return date;
    }

    private clampMemberDatesToProjectRange() {
        if (!this.listMember?.length || !this.startdate || !this.enddate) {
            return;
        }

        const projectStart = this.toDateOnly(this.startdate);
        const projectEnd = this.toDateOnly(this.enddate);

        this.listMember.forEach(x => {
            if (x.startDate) {
                const memberStart = this.toDateOnly(x.startDate);
                if (memberStart < projectStart || memberStart > projectEnd) {
                    x.startDate = this.startdate;
                }
            }
            if (x.endDate) {
                const memberEnd = this.toDateOnly(x.endDate);
                if (memberEnd > projectEnd || memberEnd < projectStart) {
                    x.endDate = this.enddate;
                }
            }
        });
    }

    getMemberStartdate(event: Date, index: number) {

        if (this.startdate && this.enddate) {
            this.listMember.forEach(x => {
                if (new Date(x.startDate?.toString()).setHours(0, 0, 0, 0) < new Date(this.startdate.toString()).setHours(0, 0, 0, 0) || new Date(x.startDate?.toString()).setHours(0, 0, 0, 0) > new Date(this.enddate.toString()).setHours(0, 0, 0, 0)) {

                    this.notify.error('Please Select Validate date range');
                    x.startDate = null;
                }
            })
        }
    }
    getMemberEnddate(event: Date, index: number) {
        if (this.startdate && this.enddate) {
            this.listMember.forEach(x => {
                if (new Date(x.startDate?.toString()).setHours(0, 0, 0, 0) > new Date(x.endDate?.toString()).setHours(0, 0, 0, 0)) {
                    this.notify.error('Please Select Validate date range');
                    x.endDate = null;
                    this.dataRangePicker.bsValue = null;
                }

            })
        }
    }
    //
    // Get Date Format and Bind the With UI
    //
    getDateFormate() {
        if (AppConsts.dateFormatId !== undefined) {
            this.diDate = AppConsts.dateFormatId;
            this.dateFormat = this._usersDateFormatService.findUsersDateFormat(this.diDate);
            this.bsDateFormat = this.dateFormat.toUpperCase();
        }
    }

    checkDuplicate(projectName: string, projectId?: number, isEdit?: boolean) {
        this._projectServiceProxy.checkDuplicateProject(projectName, projectId, isEdit).subscribe((res) => {
            if (!res) {
                this.checkProjectDuplicate = false;
                this.saveProjectData();
            } else {
                this.checkProjectDuplicate = true;
                this.toastr.warning('Project name already exists');

            }
        });
    }

    addDevOps() {
        if (this.devProjectName === " " || this.personalAccessToken === " " || this.personalAccessToken === " ") {
            this.toastr.error("Field is empty")
        }
        this.project.devProjectName = this.devProjectName;
        this.personalAccessToken = this.personalAccessToken;
        this.projectURL = this.projectURL;

        this.isSidebarOpen = false;

        this.isSidePanel = false;

    }

    showIsTimesheetLevel1Error = false;
    showIsTimeOffLevel1Error = false;
    showIsCommercialsError = false;
    saveProjectData() {
        try {
            this._monitorService.logTrace("UI-saveProjectData", { "saveProjectData ": "saveProjectData:action " + this + this.dateTime });
            this.project.projectBillingType = this.projectBillableSelected;
            this.project.projectStatus = this.projectStatusSelected;
            this.project.billabilityStatusAuthority = this.project.billabilityStatusAuthority ?? this.editProject?.billabilityStatusAuthority ?? false;
            if (this.flag !== 1) {
                this.clientStyle = true;
            }
            if (this.teamMemberFlagId !== 1) {
                this.teamMemberStyle = true;
            }
            if (this.productServiceId !== 1) {
                this.serviceProductFlagStyle = true;
            }
            this.timesheetForm.form.markAllAsTouched();

            //Checking if project duration is less than teams working hours
            if (!this.ProjectHoursValidationIsvalid(this.listMember, this.project.hourlyBudget)) {
                this.projDurationValid = false;
                this.toastr.warning(this.getProjectHoursValidationMessage() || 'Project Duration should be greater than teams working hours');
                return;
            }
            if (!this.TeamMinMaxHoursValidationIsvalid(this.listMember, this.project.hourlyBudget)) {
                this.toastr.warning(this.getTeamHoursValidationMessage() || 'Please correct team member daily hours');
                return;
            }
            if (this.wantsTofillTimesheetApprover() && !this.projectTimesheetValid()) {

                this.accordianOpen(2);
                this.toastr.warning('Please complete timesheet approval settings');
                return;
            }
            if (this.wantsTofillTimesheetApprover() && (this.approverDetailLevel1 == undefined || this.approverDetailLevel1.WindowEnum == undefined || this.approverDetailLevel1.WindowNum == undefined || this.approverDetailLevel1.user == undefined)) {

                this.accordianOpen(2);

                this.showIsTimesheetLevel1Error = true;
                if (this.projectTimeOffdata == undefined || this.projectTimeOffdata.approverIdLevelOne == undefined) {
                    this.showIsTimeOffLevel1Error = true;
                    this.toastr.warning('Please complete project approval settings');
                    return;
                }
                this.toastr.warning('Please complete timesheet approval settings');
                return;
            }

            if(!this.projectStatusSelected || !this.startdate ||  !this.projectBillableSelected || (this.projectType === 1 && this.project.flatRate <= 0) ||
                (this.projectType === 2 && this.project.singleRatePerHour <= 0)

            ){

                this.accordianOpen(4);
                this.showIsCommercialsError=true;
                this.toastr.warning('Please complete project commercial details');
                return;
            }
            if (!this.projectId && this.wantsTofillTimeOffApprover()) {
                if (this.projectTimeOffdata == undefined || this.projectTimeOffdata.approverIdLevelOne == undefined) {
                    this.accordianOpen(3);
                    this.showIsTimeOffLevel1Error = true;
                    this.toastr.warning('Please complete project approval settings');
                    return;
                }
            }

            let res = this.wantsTofillTimeOffApprover() ? this.projectTimeOffApprovalComponentInstace.checkDataForApproval() : true;
            if (!res) {
                this.accordianOpen(3);
                this.toastr.warning('Please complete project approval settings');
                return;
            }

            this.project.assignedProgramManager = this.programManager?.id;
            this.project.assignedProjectManager = this.projectManager?.map(x => x.id);
            if (this.isProjectReadyToSave()) {
                // save image to blob
                let blobImageDto = new StoreImageOnBlobDto();
                blobImageDto.tenantId = this.appSession.tenant.id;
                blobImageDto.imgBase64String = this.imagePath ? this.imagePath.split(",")[1] : null;
                this._blobHelperServiceProxy.getUrlAfterImageBlobStorage(blobImageDto).subscribe({
                    next: (imgLink) => {
                    this.project.projectImage = imgLink ? imgLink : this.imagePath;
                    this.project.clientId = this.clientsdata?.id;
                    this.project.singleRatePerHour = this.project.singleRatePerHour;
                    this.project.projectStatus = this.project.projectStatus;
                    this.project.flatRate = this.project.flatRate;
                    this.project.singleRatePerHour = this.project.singleRatePerHour;

                    this.project.projectURL = this.projectURL;
                    this.project.devProjectName = this.devProjectName;
                    this.project.personalAccessToken = this.personalAccessToken;

                    if (this.listMember.length !== 0) {
                        this.teamMemberStyle = false;
                        let teamMembers: ProjectTeamCreateOrEditDto[] = [];
                        this.listMember.forEach((x) => {
                            let obj = new ProjectTeamCreateOrEditDto();

                            obj.tenantId = this.project.tenantId;
                            obj.userId = x.userId;
                            obj.id = x.id;
                            obj.projectRole = x.projectRole;
                            obj.userBillingRate = x.userBillingRate;
                            if (!x.startDate || !x.endDate) return;
                            obj.startDate = DateTime.fromJSDate(this.timeOffService.setZeroTimeForLocalDate(new Date(x.startDate.toString())));
                            obj.endDate = DateTime.fromJSDate(this.timeOffService.setZeroTimeForLocalDate(new Date(x.endDate.toString())));
                            if (x.weeklyMaxHrs < 0 || x.weeklyMaxHrs == undefined) {
                                return;
                            }
                            if (x.weeklyMinHrs < 0 || x.weeklyMinHrs == undefined) {
                                return;
                            }
                            obj.weeklyMaxHrs = x.weeklyMaxHrs;
                            obj.weeklyMinHrs = x.weeklyMinHrs;
                            obj.projectRole = x.projectRole;
                            let obj1 = new UserListDto();
                            obj1.name = x.name;
                            obj1.emailAddress = x.emailAddress;
                            obj1.surname = x.surname;
                            obj.people = obj1;
                            teamMembers.push(obj);
                        });

                        this.project.projectTeams = [];
                        this.project.projectTeams = teamMembers;
                    }
                    if (this.serviceList.length !== 0) {
                        let tenantProductService: ProjectProductServiceCreateOrEditDto[] = [];
                        this.serviceList.forEach((x) => {
                            let obj = new ProjectProductServiceCreateOrEditDto();
                            obj.tenantProductServiceId = x.tenantProductServiceId;
                            obj.id = this.projectId ? x.id : obj.id;
                            obj.tenantId = x.tenantId;
                            obj.projectBillingServiceRate = x.projectBillingServiceRate;
                            tenantProductService.push(obj);
                        });
                        this.project.projectProductServices = tenantProductService;
                    } else {
                        this.toastr.warning('Products/Services are mandatory');
                        return;
                    }
                    if (this.startdate !== undefined) {
                        this.project.startDate = DateTime.fromJSDate(this.timeOffService.setZeroTimeForLocalDate(this.startdate));
                    }
                    this.project.endDate = DateTime.fromJSDate(this.timeOffService.setZeroTimeForLocalDate(this.enddate));

                    // ---- one
                    if (this.updateProjectTimesheetTimeLineList[0]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelOne?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[0]?.existingApprovalId != this.projectTimesheet.approverLevelOne?.id) {
                        this.updateProjectTimesheetTimeLineList[0].newApprovalId = this.projectTimesheet.approverLevelOne?.id;
                        this.updateProjectTimesheetTimeLineList[0].action = 'ExistingRemoveNewAdd';
                    }
                    else if (this.updateProjectTimesheetTimeLineList[0]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelOne?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[0]?.existingApprovalId == this.projectTimesheet.approverLevelOne?.id) {
                        this.updateProjectTimesheetTimeLineList[0].action = 'Same';
                        this.updateProjectTimesheetTimeLineList[0].sequenceNo = 1;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[0]?.existingApprovalId == undefined && this.projectTimesheet.approverLevelOne?.id != undefined) {
                        this.updateProjectTimesheetTimeLineList[0] = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineList[0].newApprovalId = this.projectTimesheet.approverLevelOne?.id;
                        this.updateProjectTimesheetTimeLineList[0].action = 'NewAdd';
                        this.updateProjectTimesheetTimeLineList[0].sequenceNo = 1;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[0]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelOne?.id == undefined) {
                        this.updateProjectTimesheetTimeLineList[0].sequenceNo = 1;
                        this.updateProjectTimesheetTimeLineList[0].action = 'Remove';
                    }

                    // ---- two

                    if (this.updateProjectTimesheetTimeLineList[1]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelTwo?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[1]?.existingApprovalId != this.projectTimesheet.approverLevelTwo?.id) {
                        this.updateProjectTimesheetTimeLineList[1].newApprovalId = this.projectTimesheet.approverLevelTwo?.id;
                        this.updateProjectTimesheetTimeLineList[1].action = 'ExistingRemoveNewAdd';
                    }
                    else if (this.updateProjectTimesheetTimeLineList[1]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelTwo?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[1]?.existingApprovalId == this.projectTimesheet.approverLevelTwo?.id) {
                        this.updateProjectTimesheetTimeLineList[1].action = 'Same';
                        this.updateProjectTimesheetTimeLineList[1].sequenceNo = 2;
                    }
                    else if (this.updateProjectTimesheetTimeLineList[1]?.existingApprovalId == undefined && this.projectTimesheet.approverLevelTwo?.id != undefined) {
                        this.updateProjectTimesheetTimeLineList[1] = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineList[1].newApprovalId = this.projectTimesheet.approverLevelTwo?.id;
                        this.updateProjectTimesheetTimeLineList[1].action = 'NewAdd';
                        this.updateProjectTimesheetTimeLineList[1].sequenceNo = 2;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[1]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelTwo?.id == undefined) {
                        this.updateProjectTimesheetTimeLineList[1].sequenceNo = 2;
                        this.updateProjectTimesheetTimeLineList[1].action = 'Remove';
                    }

                    // ---- three

                    if (this.updateProjectTimesheetTimeLineList[2]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelThree?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[2]?.existingApprovalId != this.projectTimesheet.approverLevelThree?.id) {
                        this.updateProjectTimesheetTimeLineList[2].newApprovalId = this.projectTimesheet.approverLevelThree?.id;
                        this.updateProjectTimesheetTimeLineList[2].action = 'ExistingRemoveNewAdd';
                    }
                    else if (this.updateProjectTimesheetTimeLineList[2]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelThree?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[2]?.existingApprovalId == this.projectTimesheet.approverLevelThree?.id) {
                        this.updateProjectTimesheetTimeLineList[2].action = 'Same';
                        this.updateProjectTimesheetTimeLineList[2].sequenceNo = 3;
                    }
                    else if (this.updateProjectTimesheetTimeLineList[2]?.existingApprovalId == undefined && this.projectTimesheet.approverLevelThree?.id != undefined) {
                        this.updateProjectTimesheetTimeLineList[2] = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineList[2].newApprovalId = this.projectTimesheet.approverLevelThree?.id;
                        this.updateProjectTimesheetTimeLineList[2].action = 'NewAdd';
                        this.updateProjectTimesheetTimeLineList[2].sequenceNo = 3;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[2]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelThree?.id == undefined) {
                        this.updateProjectTimesheetTimeLineList[2].sequenceNo = 3;
                        this.updateProjectTimesheetTimeLineList[2].action = 'Remove';
                    }

                    // ---- four

                    if (this.updateProjectTimesheetTimeLineList[3]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelFour?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[3]?.existingApprovalId != this.projectTimesheet.approverLevelFour?.id) {
                        this.updateProjectTimesheetTimeLineList[3].newApprovalId = this.projectTimesheet.approverLevelFour?.id;
                        this.updateProjectTimesheetTimeLineList[3].action = 'ExistingRemoveNewAdd';
                    }
                    else if (this.updateProjectTimesheetTimeLineList[3]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelFour?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[3]?.existingApprovalId == this.projectTimesheet.approverLevelFour?.id) {
                        this.updateProjectTimesheetTimeLineList[3].action = 'Same';
                        this.updateProjectTimesheetTimeLineList[3].sequenceNo = 4;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[3]?.existingApprovalId == undefined && this.projectTimesheet.approverLevelFour?.id != undefined) {
                        this.updateProjectTimesheetTimeLineList[3] = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineList[3].newApprovalId = this.projectTimesheet.approverLevelFour?.id;
                        this.updateProjectTimesheetTimeLineList[3].action = 'NewAdd';
                        this.updateProjectTimesheetTimeLineList[3].sequenceNo = 4;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[3]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelFour?.id == undefined) {
                        this.updateProjectTimesheetTimeLineList[3].sequenceNo = 4;
                        this.updateProjectTimesheetTimeLineList[3].action = 'Remove';
                    }

                    // ---- five

                    if (this.updateProjectTimesheetTimeLineList[4]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelFive?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[4]?.existingApprovalId != this.projectTimesheet.approverLevelFive?.id) {
                        this.updateProjectTimesheetTimeLineList[4].newApprovalId = this.projectTimesheet.approverLevelFive?.id;
                        this.updateProjectTimesheetTimeLineList[4].action = 'ExistingRemoveNewAdd';
                    }
                    else if (this.updateProjectTimesheetTimeLineList[4]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelFive?.id != undefined
                        && this.updateProjectTimesheetTimeLineList[4]?.existingApprovalId == this.projectTimesheet.approverLevelFive?.id) {
                        this.updateProjectTimesheetTimeLineList[4].action = 'Same';
                        this.updateProjectTimesheetTimeLineList[4].sequenceNo = 5;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[4]?.existingApprovalId == undefined && this.projectTimesheet.approverLevelFive?.id != undefined) {
                        this.updateProjectTimesheetTimeLineList[4] = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineList[4].newApprovalId = this.projectTimesheet.approverLevelFive?.id;
                        this.updateProjectTimesheetTimeLineList[4].action = 'NewAdd';
                        this.updateProjectTimesheetTimeLineList[4].sequenceNo = 5;
                    }

                    else if (this.updateProjectTimesheetTimeLineList[4]?.existingApprovalId != undefined && this.projectTimesheet.approverLevelFive?.id == undefined) {
                        this.updateProjectTimesheetTimeLineList[4].sequenceNo = 5;
                        this.updateProjectTimesheetTimeLineList[4].action = 'Remove';
                    }

                    // client approval
                    if (this.updateClientTimesheetTimeLineList?.length > 0) {

                        // first level client
                        if (this.clientContactApprovers[0] != undefined && this.updateClientTimesheetTimeLineList[0] != undefined
                            && this.updateClientTimesheetTimeLineList[0].existingApprovalId != this.clientContactApprovers[0].userId) {
                            this.updateClientTimesheetTimeLineList[0].newApprovalId = this.clientContactApprovers[0].userId;
                            this.updateClientTimesheetTimeLineList[0].action = 'ClientExistingRemoveNewAdd';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[0]);
                        }
                        else if (this.clientContactApprovers[0] != undefined && this.updateClientTimesheetTimeLineList[0] != undefined
                            && this.updateClientTimesheetTimeLineList[0].existingApprovalId == this.clientContactApprovers[0].userId) {
                            this.updateClientTimesheetTimeLineList[0].action = 'SameClient';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[0]);
                        }
                        else if (this.updateClientTimesheetTimeLineList[0] == undefined && this.clientContactApprovers[0] != undefined) {
                            this.updateClientTimesheetTimeLineList[0].newApprovalId = this.clientContactApprovers[0].userId;
                            this.updateClientTimesheetTimeLineList[0].action = 'NewAddClient';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[0]);
                        } else if (this.updateClientTimesheetTimeLineList[0] != undefined && this.clientContactApprovers[0] == undefined) {
                            this.updateClientTimesheetTimeLineList[0].action = 'RemoveClient';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[0]);
                        }

                        // second level client
                        if (this.clientContactApprovers[1] != undefined && this.updateClientTimesheetTimeLineList[1] != undefined
                            && this.updateClientTimesheetTimeLineList[1].existingApprovalId != this.clientContactApprovers[1].userId) {
                            this.updateClientTimesheetTimeLineList[1].newApprovalId = this.clientContactApprovers[1].userId;
                            this.updateClientTimesheetTimeLineList[1].action = 'ClientExistingRemoveNewAdd';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[1]);
                        }
                        else if (this.clientContactApprovers[1] != undefined && this.updateClientTimesheetTimeLineList[1] != undefined
                            && this.updateClientTimesheetTimeLineList[1].existingApprovalId == this.clientContactApprovers[1].userId) {
                            this.updateClientTimesheetTimeLineList[1].action = 'SameClient';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[1]);
                        }
                        else if (this.updateClientTimesheetTimeLineList[1] == undefined && this.clientContactApprovers[1] != undefined) {
                            this.updateClientTimesheetTimeLineList[1].newApprovalId = this.clientContactApprovers[1].userId;
                            this.updateClientTimesheetTimeLineList[1].action = 'NewAddClient';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[1]);
                        } else if (this.updateClientTimesheetTimeLineList[1] != undefined && this.clientContactApprovers[1] == undefined) {
                            this.updateClientTimesheetTimeLineList[1].action = 'RemoveClient';
                            this.updateProjectTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineList[1]);
                        }
                    }

                    let timesheet = new ProjectTimeSheetCreateEditDto();
                    timesheet.approverIdLevelOne = this.projectTimesheet.approverLevelOne?.id;
                    timesheet.approverIdLevelTwo = this.projectTimesheet.approverLevelTwo?.id;
                    timesheet.approverIdLevelThree = this.projectTimesheet.approverLevelThree?.id;
                    timesheet.approverIdLevelFour = this.projectTimesheet.approverLevelFour?.id;
                    timesheet.approverIdLevelFive = this.projectTimesheet.approverLevelFive?.id;
                    timesheet.submissionFrequency = this.projectTimesheet.submissionFrequency;
                    timesheet.approvalWindowInOne = this.projectTimesheet.approvalWindowInOne;
                    timesheet.approvalWindowOne = this.projectTimesheet.approvalWindowOne;
                    timesheet.approvalWindowInTwo = this.projectTimesheet.approvalWindowInTwo;
                    timesheet.approvalWindowTwo = this.projectTimesheet.approvalWindowTwo;
                    timesheet.approvalWindowInThree = this.projectTimesheet.approvalWindowInThree;
                    timesheet.approvalWindowThree = this.projectTimesheet.approvalWindowThree;
                    timesheet.approvalWindowInFour = this.projectTimesheet.approvalWindowInFour;
                    timesheet.approvalWindowFour = this.projectTimesheet.approvalWindowFour;
                    timesheet.approvalWindowInFive = this.projectTimesheet.approvalWindowInFive;
                    timesheet.approvalWindowFive = this.projectTimesheet.approvalWindowFive;
                    timesheet.taskAccountabilityInMinutes = this.projectTimesheet.taskAccountabilityInMinutes;
                    timesheet.notificationAlertInMinutes = this.projectTimesheet.notificationAlertInMinutes;

                    if ((timesheet.approverIdLevelOne && (!timesheet.approvalWindowInOne || !timesheet.approvalWindowOne) ||
                        (timesheet.approverIdLevelTwo && (!timesheet.approvalWindowInTwo || !timesheet.approvalWindowTwo)) ||
                        (timesheet.approverIdLevelThree && (!timesheet.approvalWindowInThree || !timesheet.approvalWindowThree)) ||
                        (timesheet.approverIdLevelFour && (!timesheet.approvalWindowInFour || !timesheet.approvalWindowFour)) ||
                        (timesheet.approverIdLevelFive && (!timesheet.approvalWindowInFive || !timesheet.approvalWindowFive)))) {
                        this.toastr.warning('Please complete timesheet approval windows');
                        return
                    }
                    if (this.isCheckTimeSheetSettings) {
                        if (timesheet.submissionFrequency === undefined || timesheet.submissionFrequency === null) {
                            this.toastr.warning('Please select timesheet submission frequency');
                            return;
                        }
                        this.project.projectTimeSheet = timesheet;
                        this.project.updatedProjectTimesheetTimeline = this.updateProjectTimesheetTimeLineList;
                    } else if (!this.isCheckTimeSheetSettings) {
                        timesheet.isDeleted = true;
                        this.project.projectTimeSheet = timesheet;
                        this.project.updatedProjectTimesheetTimeline = this.updateProjectTimesheetTimeLineList;
                    }
                    if (this.selectedClientContacts.length && this.projectId) {
                        this.selectedClientContacts.forEach(c => {
                            let temp = new ProjectClientApproversDto();
                            temp.projectId = this.projectId;
                            temp.creatorUserId = c.userId;
                        });
                    }
                    if (this.projectTimeOffdata == null && this.editProject?.projectTimeOff != null) {
                        this.projectTimeOffdata = new ProjectTimeOffCreateOrEditDto();
                        //Level 1
                        this.projectTimeOffdata.approvalWindowInOne = this.editProject.projectTimeOff?.approvalWindowInOne;
                        this.projectTimeOffdata.approverIdLevelOne = this.editProject.projectTimeOff?.approverIdLevelOne;
                        this.projectTimeOffdata.approvalWindowOne = this.editProject.projectTimeOff?.approvalWindowOne;

                        //Level 2
                        this.projectTimeOffdata.approvalWindowInTwo = this.editProject.projectTimeOff?.approvalWindowInTwo;
                        this.projectTimeOffdata.approverIdLevelTwo = this.editProject.projectTimeOff?.approverIdLevelTwo;
                        this.projectTimeOffdata.approvalWindowTwo = this.editProject.projectTimeOff?.approvalWindowTwo;

                        //Level 3
                        this.projectTimeOffdata.approvalWindowInThree = this.editProject.projectTimeOff?.approvalWindowInThree;
                        this.projectTimeOffdata.approverIdLevelThree = this.editProject.projectTimeOff?.approverIdLevelThree;
                        this.projectTimeOffdata.approvalWindowThree = this.editProject.projectTimeOff?.approvalWindowThree;

                        //Level 4
                        this.projectTimeOffdata.approvalWindowInFour = this.editProject.projectTimeOff?.approvalWindowInFour;
                        this.projectTimeOffdata.approverIdLevelFour = this.editProject.projectTimeOff?.approverIdLevelFour;
                        this.projectTimeOffdata.approvalWindowFour = this.editProject.projectTimeOff?.approvalWindowFour;

                        //Level 5
                        this.projectTimeOffdata.approvalWindowInFive = this.editProject.projectTimeOff?.approvalWindowInFive;
                        this.projectTimeOffdata.approverIdLevelFive = this.editProject.projectTimeOff?.approverIdLevelFive;
                        this.projectTimeOffdata.approvalWindowFive = this.editProject.projectTimeOff?.approvalWindowFive;
                    }

                    if (this.projectTimeOffdata?.approverIdLevelOne && (!this.projectTimeOffdata?.approvalWindowInOne || !this.projectTimeOffdata?.approvalWindowOne)) {
                        this.toastr.warning('Please complete project time off approval window');
                        return;
                    }
                    this.project.projectTimeOff = this.projectTimeOffdata;
                    this.clientContactApprovers.forEach(cc => {
                        cc.approvalWindowOne = this.clientApprovalWindow;
                        cc.approvalWindowInOne = this.clientApprovalWindowInEnum;
                    })
                    this.project.projectClientApprovers = this.clientContactApprovers;
                    if (this.deleteServiceList != null) {
                        this.deleteServiceList.forEach((x) => {
                            let list = new ProjectProductServiceCreateOrEditDto();
                            (list.id = x.id),
                                (list.tenantProductServiceId = x.tenantProductServiceId),
                                (list.isDeleted = true),
                                this.project.projectProductServices.push(list);
                        });
                    }
                    if (!this.wantsTofillTimesheetApprover()) timesheet = new ProjectTimeSheetCreateEditDto();
                    this.project.firstApprover = this.firstMemberList;
                    this.project.secondApprover = this.secondMemberList;
                    this.submitted1 = true;
                    this.isLoading = true;
                    this._spinnerService.show();

                    if (
                        this.project.clientId !== undefined &&
                        this.project.name !== null &&
                        (this.project.projectProductServices && this.project.projectProductServices.length !== 0) &&
                        this.project.projectTeams.length !== 0 &&
                        !this.isOnlySpaceInString
                    ) {
                        if (this.saving) return;
                        this.saving = true;

                        this.project.devProjectName = this.devProjectName;
                        this.project.personalAccessToken = this.personalAccessToken;
                        this.project.projectURL = this.projectURL;
                        this._projectServiceProxy
                            .createOrEdit(this.project)
                            .pipe(
                                finalize(() => {
                                    this.isLoading = true;
                                    this._spinnerService.hide();
                                })
                            )
                            .subscribe(
                                async (projectId) => {
                                    try {
                                        const savedProjectId = projectId || this.project.id;
                                        if (savedProjectId && this.projectDocsUpload) {
                                            await this.projectDocsUpload.uploadPendingFiles(savedProjectId);
                                        }
                                    } catch {
                                        this.toastr.warning(this.l("Error"));
                                    }
                                    this.project.id ? this.toastr.success(this.l("Changesupdatedsuccessfully")) : this.toastr.success(this.l("Newprojectaddedsuccessfully"));

                                    this._router.navigate([AppRoutes.projects]);
                                    this.teamMemberStyle = false;
                                    this.clientStyle = false;
                                    this.serviceProductFlagStyle = false;
                                    this.projectAdded.emit();
                                    this.saving = false;
                                },
                                (e) => {
                                    this.saving = false;
                                    this.toastr.error(this.l("Error"));
                                }
                            );
                    } else {
                        this.saving = false;
                        this.isLoading = false;
                        this._spinnerService.hide();
                        this.toastr.warning('Please complete required project details');
                    }
                    },
                    error: () => {
                        this.saving = false;
                        this.isLoading = false;
                        this._spinnerService.hide();
                        this.toastr.error(this.l("Error"));
                    }
                });
            } else {
                this.toastr.warning(this.getProjectSaveValidationMessage() || 'Please complete required project details');
            }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    save() {

        this.dataSubmitted = true;
        if (this.editProject && this.editProject.projectTimeOff) {
            this.projectFormSubmitted = true;
        }
        if (!this.editProject) {
            this.projectFormSubmitted = true;

        }
        this._monitorService.logEvent("Save", { "Save": "Save: action" + this.msg + this.dateTime });

        //to avoid multiple clicks on project save button
        if (this.saving) return;

        //optional Time off approval selection
        if (this.wantsTofillTimeOffApprover()) {
            if (!this.projectId) {
                if (this.projectTimeOffdata == undefined && this.projectId == null) {
                    this.accordianOpen(3);
                    return;
                }
            }
        }

        this.projectForm.form.markAllAsTouched();

        const validationMessage = this.getProjectSaveValidationMessage();
        if (validationMessage) {
            this.toastr.warning(validationMessage);
            return;
        }
        this.canceledSaved = true;

        if (this.project.id) {
            this.saveProjectData();
        } else {
            this.checkDuplicate(this.project.name);
        }
    }

    private getProjectSaveValidationMessage(): string | null {
        if (!this.project.name?.trim()) {
            return 'Project name is mandatory';
        }
        if (!this.clientsdata?.id) {
            return 'Client is mandatory';
        }
        if (!this.projectBillableSelected) {
            return 'Billability is mandatory';
        }
        if (!this.projectStatusSelected) {
            return 'Project status is mandatory';
        }
        if (!this.startdate) {
            return 'Start Date is mandatory';
        }
        if (!this.enddate) {
            return 'End Date is mandatory';
        }
        if (!this.project.hourlyBudget) {
            return 'Project Duration is mandatory';
        }
        if (!this.projectManager?.length) {
            return 'Project Manager is mandatory';
        }
        if (!this.listMember?.length) {
            return 'Team Members are mandatory';
        }
        if (!this.serviceList?.length) {
            return 'Products/Services are mandatory';
        }
        if (this.projectType === 1 && !(this.project.flatRate > 0)) {
            return 'Flat Rate is mandatory';
        }
        if (this.projectType === 2 && !(this.project.singleRatePerHour > 0)) {
            return 'Hourly Rate is mandatory';
        }
        if (this.checkProjectDuplicate) {
            return 'Project name already exists';
        }

        const invalidMember = this.listMember.find(member =>
            !member.projectRole ||
            member.userBillingRate === undefined ||
            member.userBillingRate === null ||
            !member.startDate ||
            !member.endDate ||
            !(member.weeklyMinHrs > 0) ||
            !(member.weeklyMaxHrs > 0) ||
            member.weeklyMinHrs > member.weeklyMaxHrs ||
            member.weeklyMinHrs > this.maxDailyHours ||
            member.weeklyMaxHrs > this.maxDailyHours
        );

        if (invalidMember) {
            if (invalidMember.weeklyMinHrs > this.maxDailyHours || invalidMember.weeklyMaxHrs > this.maxDailyHours) {
                return 'Daily hours cannot exceed 24.';
            }
            return 'Please complete team member role, dates, billing rate, and weekly hours';
        }

        this.updateProjectHoursValidation();
        if (!this.projDurationValid) {
            return this.getProjectHoursValidationMessage();
        }

        return null;
    }

    private isProjectReadyToSave(): boolean {
        return this.getProjectSaveValidationMessage() === null;
    }

    close() {

        this.appModalPopup.show(2);
    }
    navigateToProjects() {
        this.canceledSaved = true;

        this._router.navigate([AppRoutes.projects]);

        if (this.projectService.navigatedFromDatailPage) {
            this.projectService.navigatedFromDatailPage = false;
            this._router.navigate([AppRoutes.projectsDetails], { state: { ProjectId: this.projectId, option: Number(this.projectType) }, queryParams: { ProjectId: this.projectId, option: Number(this.projectType) } });
            return;
        }
        if (this.projectId) this._router.navigate([AppRoutes.projects]);
        this.projectAdded.emit();
    }
    cancelNavigationtoUser() { }

    CloseAssignedClientDropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }

    getActiveClients() {
        if (!this.textName) {

            this.getAllClients();
            return;
        }
        this._clientServiceProxy.getClientByName(this.textName, ClientType3.AllClients).subscribe((result) => {
            this.allClients = result;
        });
    }

    getUsers() {
        this._monitorService.logTrace("UI-getUsers", { "getUsers ": "getUsers: called" + this.msg + this.dateTime })
        this._userServiceProxy
            .getUsers(
                this.filter,
                undefined,
                this.role !== "" ? parseInt(this.role) : undefined,
                undefined,
                this.onlyLockedUsers,
                false,
                undefined,
                undefined,
                undefined,
                undefined
            )
            .subscribe((result) => {
                this.editShow(this.projectId);
                result.items.forEach(x => {
                    x.profileImage = x.profileImage ? x.profileImage : 'assets/common/images/default-profile-picture1.svg';
                });
                this.userRecords = result.items;
                this.ProgramManagerUsers = result.items.filter(x => this.isUserProgrammanager(x));
                this.ProjectManagerUsers = result.items.filter(x => this.isUserManager(x));

                let Id: UserListRoleDto = new UserListRoleDto();
                Id.roleId = 0;
                Id.roleName = '-'
                result.items.forEach((y) => {
                    if (y.roles.length == 0 || y.roles == undefined || y.roles == null) {
                        y.roles = [];
                        y.roles.push(Id)
                    }
                })

                this.primengTableHelper.records = [];
                this.tempAllMembersStore = result.items;
                this.assignSelectedData();
                this.primengTableHelper.records = this.primengTableHelper.records.filter(el => {
                    return !this.listMember?.find(element => {
                        return element.userId === el.userId;
                    });
                });

                this.primengTableHelper.records.forEach(x => {
                    if (!x.profilePictureId) {
                        x.profilePictureId = this.appRootUrl() + "assets/common/images/default-profile-picture1.svg";
                    } else {
                        this._profileService.getProfilePictureById(x.profilePictureId).subscribe((result) => {
                            if (result && result.profilePicture) {
                                x.profilePictureId = "data:image/jpeg;base64," + result.profilePicture;
                            } else {
                                x.profilePictureId = this.appRootUrl() + "assets/common/images/default-profile-picture1.svg";
                            }
                            this.refreshProjectView();
                        });
                    }
                });

                this.usersData = this.primengTableHelper.records;
                this.syncEditSelectionsAfterUsersLoad();
                this.refreshProjectView();
            });
    }
    getAllUsers() {

        this.ProgramManagerUsers = this.userRecords.filter(x => this.isUserProgrammanager(x));
        this.ProjectManagerUsers = this.userRecords.filter(x => this.isUserManager(x));
    }
    isUserProgrammanager(usersData: UserListDto) {
        let isPM = false;
        usersData.roles.forEach(x => {
            if (x.roleName == "Program Manager" || x.roleId == 4) {
                isPM = true;
            }
        });
        return isPM;
    }

    isUserManager(usersData: UserListDto) {
        let isManager = false;
        usersData.roles.forEach(x => {
            if (x.roleName == "Manager" || x.roleId == 3) {
                isManager = true;
            }
        });
        return isManager;
    }

    TimeSheetLevel1(data: ApproverDetail) {
        this.showIsTimesheetLevel1Error = false;
        this.approverDetailLevel1 = data;
        this.projectTimesheet.approvalWindowInOne = data.WindowEnum;
        this.projectTimesheet.approvalWindowOne = data.WindowNum;
        this.projectTimesheet.approverLevelOne = data.user;

    }
    TimeSheetLevel2(data: ApproverDetail) {

        this.approverDetailLevel2 = data;
        if (data.WindowEnum || true) {
            this.projectTimesheet.approvalWindowInTwo = data.WindowEnum;
        }
        if (data.WindowNum || true) {
            this.projectTimesheet.approvalWindowTwo = data.WindowNum;
        }
        this.projectTimesheet.approverLevelTwo = data.user;

    }
    TimeSheetLevel3(data: ApproverDetail) {

        if (data.WindowEnum || true) {
            this.projectTimesheet.approvalWindowInThree = data.WindowEnum;
            this.approverDetailLevel3.WindowEnum = data.WindowEnum;
        }
        if (data.WindowNum || true) {
            this.projectTimesheet.approvalWindowThree = data.WindowNum;
            this.approverDetailLevel3.WindowNum = data.WindowNum;
        }
        this.projectTimesheet.approverLevelThree = data.user;
        this.approverDetailLevel3.user = data.user;

    }
    TimeSheetLevel4(data: ApproverDetail) {

        this.approverDetailLevel4 = data;
        if (data.WindowEnum || true) this.projectTimesheet.approvalWindowInFour = data.WindowEnum;
        if (data.WindowNum || true) this.projectTimesheet.approvalWindowFour = data.WindowNum;
        this.projectTimesheet.approverLevelFour = data.user;

    }
    TimeSheetLevel5(data: ApproverDetail) {

        this.approverDetailLevel5 = data;
        if (data.WindowEnum || true) this.projectTimesheet.approvalWindowInFive = data.WindowEnum;
        if (data.WindowNum || true) this.projectTimesheet.approvalWindowFive = data.WindowNum;
        this.projectTimesheet.approverLevelFive = data.user;

    }

    compareUserById = (a: UserListDto, b: UserListDto): boolean => a?.id === b?.id;

    compareTeamMemberByUserId = (a: ProjectTeamGetAllDto, b: ProjectTeamGetAllDto): boolean =>
        (a?.userId ?? a?.id) === (b?.userId ?? b?.id);

    private managerDropdownOptions(): UserListDto[] {
        return [...this.ProgramManagerUsers, ...this.ProjectManagerUsers, ...this.userRecords];
    }

    editShow(projectId): void {
        this._monitorService.logTrace("UI-editShow", { "editShow ": "editShow:action " + this + this.dateTime })
        if (!projectId) {
            this.isNewProject = true;
        } else {
            this.dateCustFormat = this.dateFormat;

            this._spinnerService.show();
            if (!this.projectTimesheet.approverLevelThree) {
                this.addMoreLevel = false;
                this.level4disabled = false;
            }
            this.isNewProject = false;
            this._projectServiceProxy.getProjectById(projectId).subscribe((result) => {
                this.editProject = result;
                this.project.projectType = !this.editProject.flatRate ? 2 : 1;
                this.projectbillabityAccess = this.editProject.billabilityStatusAuthority?'1':'2' ;
                this.projectBillableSelected = result.projectBillingType;
                this.projectStatusSelected = result.projectStatus;
                this.projectManager = this.projectService.resolveAssignedProjectManagers(result, this.managerDropdownOptions());
                this.programManager = this.projectService.resolveAssignedProgramManager(result, this.managerDropdownOptions());
                this.ProgramManagerUsers = this.projectService.includeAssignedUsers(this.ProgramManagerUsers, this.programManager ? [this.programManager] : []);
                this.ProjectManagerUsers = this.projectService.includeAssignedUsers(this.ProjectManagerUsers, this.projectManager);
                this._spinnerService.hide();
                this.isSaveVisible = false;
                this.project.name = result.name;
                this.project.hourlyBudget = result.hourlyBudget;
                this.project.projectBillingType = result.projectBillingType;
                this.project.flatRate = result.flatRate;

                this.devProjectName = result.devProjectName;
                this.personalAccessToken = result.personalAccessToken;
                this.projectURL = result.projectURL;

                this.imagePath = result.projectImage;
                this.project.description = result.description;
                this.project.singleRatePerHour = result.singleRatePerHour;
                this.startdate = new Date(result.startDate.toString());
                this.enddate = result.endDate !== undefined ? new Date(result.endDate.toString()) : null;
                this.minDate = this.startdate;
                this.maxDate = this.enddate;
                this.project.id = result.id;
                this.onRowSelect(result.client);
                this.project.projectClientApprovers = result.projectClientApprovers;
                this.clientContactApprovers = result.projectClientApprovers;
                if (this.clientContactApprovers[0]) {
                    this.clientApprovalWindow = this.clientContactApprovers[0].approvalWindowOne;
                    this.clientApprovalWindowInEnum = this.clientContactApprovers[0].approvalWindowInOne;
                }

                if (result.projectType > 0) {
                    this.projectType = result.projectType;
                    this.setProjectType(result.projectType);
                }
                this.project.tenantId = result.tenantId;
                this.projectEditData = result;
                this.clientsdata = result?.client;
                this.selectedClientContacts = this.clientsdata?.clientContacts;

                if (result.projectTimeSheet != null) {
                    //assigning timesheetdata and levels to show
                    this.HideProjTimeSheetChk = true;
                    this.isCheckTimeSheetSettings = true;
                    this.updateProjectTimesheetTimeLineList = [];
                    this.updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();

                    this.projectTimesheet = result.projectTimeSheet;
                    //TS level 1
                    this.approverDetailLevel1.WindowEnum = this.projectTimesheet.approvalWindowInOne;
                    this.approverDetailLevel1.WindowNum = this.projectTimesheet.approvalWindowOne;
                    this.approverDetailLevel1.user = this.projectTimesheet.approverLevelOne;

                    if (this.projectTimesheet.approverLevelOne != undefined) {
                        this.updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineDetails.existingApprovalId = this.projectTimesheet.approverLevelOne.id;
                        this.updateProjectTimesheetTimeLineDetails.sequenceNo = 1;
                        this.updateProjectTimesheetTimeLineList.push(this.updateProjectTimesheetTimeLineDetails);
                    }

                    //TS level 2
                    this.approverDetailLevel2.WindowEnum = this.projectTimesheet.approvalWindowInTwo;
                    this.approverDetailLevel2.WindowNum = this.projectTimesheet.approvalWindowTwo;
                    this.approverDetailLevel2.user = this.projectTimesheet.approverLevelTwo;

                    if (this.projectTimesheet.approverLevelTwo != undefined) {
                        this.updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineDetails.existingApprovalId = this.projectTimesheet.approverLevelTwo.id;
                        this.updateProjectTimesheetTimeLineDetails.sequenceNo = 2;
                        this.updateProjectTimesheetTimeLineList.push(this.updateProjectTimesheetTimeLineDetails);
                    }

                    //TS level 3
                    this.approverDetailLevel3.WindowEnum = this.projectTimesheet.approvalWindowInThree;
                    this.approverDetailLevel3.WindowNum = this.projectTimesheet.approvalWindowThree;
                    this.approverDetailLevel3.user = this.projectTimesheet.approverLevelThree;

                    if (this.projectTimesheet.approverLevelThree != undefined) {
                        this.updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineDetails.existingApprovalId = this.projectTimesheet.approverLevelThree.id;
                        this.updateProjectTimesheetTimeLineDetails.sequenceNo = 3;
                        this.updateProjectTimesheetTimeLineList.push(this.updateProjectTimesheetTimeLineDetails);
                    }

                    //TS level 4
                    this.approverDetailLevel4.WindowEnum = this.projectTimesheet.approvalWindowInFour;
                    this.approverDetailLevel4.WindowNum = this.projectTimesheet.approvalWindowFour;
                    this.approverDetailLevel4.user = this.projectTimesheet.approverLevelFour;

                    if (this.projectTimesheet.approverLevelFour != undefined) {
                        this.updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineDetails.existingApprovalId = this.projectTimesheet.approverLevelFour.id;
                        this.updateProjectTimesheetTimeLineDetails.sequenceNo = 4;
                        this.updateProjectTimesheetTimeLineList.push(this.updateProjectTimesheetTimeLineDetails);
                    }

                    //TS level 5
                    this.approverDetailLevel5.WindowEnum = this.projectTimesheet.approvalWindowInFive;
                    this.approverDetailLevel5.WindowNum = this.projectTimesheet.approvalWindowFive;
                    this.approverDetailLevel5.user = this.projectTimesheet.approverLevelFive;

                    if (this.projectTimesheet.approverLevelFive != undefined) {
                        this.updateProjectTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                        this.updateProjectTimesheetTimeLineDetails.existingApprovalId = this.projectTimesheet.approverLevelFive.id;
                        this.updateProjectTimesheetTimeLineDetails.sequenceNo = 5;
                        this.updateProjectTimesheetTimeLineList.push(this.updateProjectTimesheetTimeLineDetails);
                    }

                    this.AppoverLevelShowOnEdit(this.projectTimesheet);
                } else {
                    this.isCheckTimeSheetSettings = false;
                    this.projectTimesheet = new ProjectTimeSheetGetAllDto();
                    this.projectTimesheet.submissionFrequency = 0 as any;
                    this.projectTimesheet.approvalWindowInFive = 1;
                    this.projectTimesheet.approvalWindowInFour = 1;
                    this.projectTimesheet.approvalWindowInThree = 1;
                    this.projectTimesheet.approvalWindowInTwo = 1;
                    this.projectTimesheet.approvalWindowInOne = 1;
                    this.projectTimesheet.taskAccountabilityInMinutes = 120;
                    this.projectTimesheet.notificationAlertInMinutes = 30;
                }

                this.updateClientTimesheetTimeLineList = [];
                this.updateClientTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();

                if (result.projectClientApprovers[0] != undefined) {
                    this.updateClientTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                    this.updateClientTimesheetTimeLineDetails.existingApprovalId = result.projectClientApprovers[0].userId;
                    this.updateClientTimesheetTimeLineDetails.sequenceNo = 6;
                    this.updateClientTimesheetTimeLineDetails.action = 'Client_Existing';
                    this.updateClientTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineDetails);
                }

                if (result.projectClientApprovers[1] != undefined) {
                    this.updateClientTimesheetTimeLineDetails = new UpdateProjectTimesheetTimeLineDto();
                    this.updateClientTimesheetTimeLineDetails.existingApprovalId = result.projectClientApprovers[1].userId;
                    this.updateClientTimesheetTimeLineDetails.sequenceNo = 7;
                    this.updateClientTimesheetTimeLineDetails.action = 'Client_Existing';
                    this.updateClientTimesheetTimeLineList.push(this.updateClientTimesheetTimeLineDetails);
                }

                this.isTimesheetSubmitted = result.isTimeSheetSubmitted;
                if (this.clientsdata?.id) {
                    this.flag = 1;
                }
                if (result.tenantProductService?.length) {
                    result.tenantProductService.forEach((x) => {
                        this.serviceList = result.tenantProductService;
                        if (this.serviceList.length !== 0) {
                            this.productServiceId = 1;
                        }
                    });
                    this.mangerSelecteShow = false;
                    this.mangerSelecteShowService = false;
                }
                //to take service data and bind to requied type
                this.bindSelectedProductServices();
                (result.teamMembers ?? []).forEach((x) => {
                    if (!x.profilePictureId) {
                        x.profilePictureId = this.appRootUrl() + "assets/common/images/default-profile-picture1.svg";
                    } else {
                        this._profileService.getProfilePictureById(x.profilePictureId).subscribe((result) => {
                            if (result && result.profilePicture) {
                                x.profilePictureId = "data:image/jpeg;base64," + result.profilePicture;
                            } else {
                                x.profilePictureId = this.appRootUrl() + "assets/common/images/default-profile-picture1.svg";
                            }
                            this.refreshProjectView();
                        });
                    }
                    if (x.startDate != null) {
                        this.tempDate = new Date(x.startDate.toString());
                        x.startDate = this.tempDate;
                    }
                    if (x.endDate != null) {
                        this.tempDate = new Date(x.endDate.toString());
                        x.endDate = this.tempDate;
                    }
                    if (x.joiningDate != null) {
                        this.tempDate = new Date(x.joiningDate.toString());
                        x.joiningDate = this.tempDate;
                    }
                });
                this.listMember = result.teamMembers ?? [];
                this.usersData = this.projectService.includeAssignedTeamMembers(this.usersData, this.listMember);
                this.selectedTeamDropdown = this.listMember;
                this.getfilteredUsers();
                this.syncTimesheetApproverDetailsFromModel();
                if (this.listMember.length !== 0) {
                    this.teamMemberFlagId = 1;
                }
                this.updateProjectHoursValidation();
                this.markForCheck();
            });
        }
    }

    // API callbacks complete outside Angular's zone, so skip painting until edit data exists
    // and then request a render. An earlier flush would hide the spinner and leave the form blank.
    private refreshProjectView(): void {
        if (this.projectId && !this.editProject) {
            return;
        }
        this.markForCheck();
    }

    private syncEditSelectionsAfterUsersLoad(): void {
        if (!this.editProject) {
            return;
        }

        this.programManager = this.projectService.resolveAssignedProgramManager(this.editProject, this.managerDropdownOptions());
        this.projectManager = this.projectService.resolveAssignedProjectManagers(this.editProject, this.managerDropdownOptions());
        this.ProgramManagerUsers = this.projectService.includeAssignedUsers(this.ProgramManagerUsers, this.programManager ? [this.programManager] : []);
        this.ProjectManagerUsers = this.projectService.includeAssignedUsers(this.ProjectManagerUsers, this.projectManager);
        if (this.listMember?.length) {
            this.usersData = this.projectService.includeAssignedTeamMembers(this.usersData, this.listMember);
            this.selectedTeamDropdown = this.listMember;
        }
        this.getfilteredUsers();
        this.syncTimesheetApproverDetailsFromModel();
    }

    private bindSelectedProductServices(): void {
        const services = this.editProject?.tenantProductService;
        if (!services?.length || !this.productServiceRecords?.length) {
            return;
        }

        this.selectedProductServiceRecords = [];
        services.forEach((service) => {
            const match = this.productServiceRecords.find(record => record.id === service.tenantProductServiceId);
            if (match) {
                this.selectedProductServiceRecords.push(match);
            }
        });
    }
    onApproverType1Added(item) {

        this.firstMemberList = item;
        this.accordianOpen(3);
    }
    onApproverType2Added(item) {
        this.secondMemberList = item;
    }
    assignSelectedData() {
        this.selectedTeamMembers = [];
        for (let i = 0; i < this.tempAllMembersStore.length; i++) {
            let x = this.tempAllMembersStore[i];
            let obj = new ProjectTeamGetAllDto();
            obj.userId = x.id;
            obj.name = x.name;
            obj.emailAddress = x.emailAddress;
            obj.phoneNumber = x.phoneNumber;
            obj.profileImage = x.profileImage;
            obj.profilePictureId = x.profilePictureId;
            obj.surname = x.surname;
            if (x.companyJoinDate != undefined) {

                this.tempDate = new Date(x.companyJoinDate.toString());
            }
            else {
                this.tempDate = new Date(x.creationTime.toString());
            }
            obj.joiningDate = this.tempDate;
            this.primengTableHelper.records.push(obj);
            (obj.fullName as string) = x.fullName;
            obj.weeklyMaxHrs = 0;
            obj.weeklyMinHrs = 0;
            for (let j = 0; j < this.listMember.length; j++) {
                if (this.listMember[j].userId === this.tempAllMembersStore[i].id) {
                    let y = this.listMember[j]
                    obj.id = y.id;
                    obj.projectRole = y.projectRole;
                    obj.userBillingRate = y.userBillingRate;
                    obj.startDate = y.startDate;
                    obj.endDate = y.endDate;
                    obj.weeklyMaxHrs = y.weeklyMaxHrs;
                    obj.weeklyMinHrs = y.weeklyMinHrs;
                    obj.projectRole = y.projectRole;
                    this.selectedTeamMembers.push(this.listMember[j]);
                }
            }
        }
    }
    public greaterThan(joiningDate, startDate) {
        if (joiningDate > startDate) {
            return joiningDate;
        }
        else {
            return startDate;
        }
    }
    showtable(tableDiv, dropdownDiv) {
        this._monitorService.logEvent("showtable", { "showtable": "showtable:action " + this.msg + this.dateTime });
        let div = document.getElementById(tableDiv);
        if (div.style.display === "none" || div.style.display != "block") {
            div.style.display = "block";
            this.isShow = false;
            this.clientStyle = false;
        } else {
            div.style.display = "none";
            this.isShow = true;
            this.clientStyle = true;
        }
        if (dropdownDiv === "scrollClient") {
            if (this.allClients.length > 4) {
                document.getElementById(dropdownDiv).classList.add("ClntDrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("ClntDrpDwnScrl");
            }
        } else if (dropdownDiv === "scrollTeamMember") {
            if (this.primengTableHelper.records.length > 4) {
                document.getElementById(dropdownDiv).classList.add("TmMbrDrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("TmMbrDrpDwnScrl");
            }
        } else if (dropdownDiv === "ScrollProjServices") {
            if (this.productServiceRecords.length > 3) {
                document.getElementById(dropdownDiv).classList.add("ProjServDrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("ProjServDrpDwnScrl");
            }
        } else if (dropdownDiv === "scrollLevel1") {
            if (this.primengTableHelper.records.length > 4) {
                document.getElementById(dropdownDiv).classList.add("Lvl1DrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("Lvl1DrpDwnScrl");
            }
        } else if (dropdownDiv === "scrollLevel2") {
            if (this.primengTableHelper.records.length > 4) {
                document.getElementById(dropdownDiv).classList.add("Lvl2DrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("Lvl2DrpDwnScrl");
            }
        } else if (dropdownDiv === "scrollLevel3") {
            if (this.primengTableHelper.records.length > 4) {
                document.getElementById(dropdownDiv).classList.add("Lvl3DrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("Lvl3DrpDwnScrl");
            }
        } else if (dropdownDiv === "scrollLevel4") {
            if (this.primengTableHelper.records.length > 4) {
                document.getElementById(dropdownDiv).classList.add("Lvl4DrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("Lvl4DrpDwnScrl");
            }
        } else if (dropdownDiv === "scrollLevel5") {
            if (this.primengTableHelper.records.length > 4) {
                document.getElementById(dropdownDiv).classList.add("Lvl5DrpDwnScrl");
            } else {
                document.getElementById(dropdownDiv).classList.remove("Lvl5DrpDwnScrl");
            }
        }
    }

    getAllClients() {
        this._clientServiceProxy.getAllClients(ClientType2.AllClients).subscribe((result) => {
            this.allClients = result;
            this.refreshProjectView();
        });
    }

    getProjectServices(event?: LazyLoadEvent) {
        this._tenantProductServiceProxy.getProductServicesByTypeId(0, -1).subscribe((result) => {
            this.productServiceRecords = result;
            this.bindSelectedProductServices();
            this.refreshProjectView();
        });
    }

    getRolesAsString(roles): string {
        let roleNames = "";
        for (let j = 0; j < roles.length; j++) {
            if (roleNames.length) {
                roleNames = roleNames + ", ";
            }
            roleNames = roleNames + roles[j].roleName;
        }
        return roleNames;
    }

    selectedTeamMember(id): String {
        let Roles;
        for (let j = 0; j < this.tempAllMembersStore.length; j++) {
            if (id === this.tempAllMembersStore[j].id) {
                Roles = this.tempAllMembersStore[j].roles;
            }
        }
        return this.getRolesAsString(Roles);
    }

    onRowSelect(data: ClientDto) {
        if (data == undefined) return;

        this.isShow = false;
        this.clientsdata = data;
        this.selectedClientContacts = this.clientsdata ? this.clientsdata.clientContacts : this.selectedClientContacts;
        this.clientContactDropdown = [];
        this.selectedClientContacts.forEach(x => {
            let tempvar = new ProjectClientApproversDto();
            tempvar.clientId = x.clientId;
            tempvar.clientContactId = x.id;
            tempvar.clientContactRoleId = x.clientContactRoleId;
            tempvar.clientId = x.clientId;
            tempvar.email = x.email;
            tempvar.firstName = x.firstName;
            tempvar.lastName = x.lastName;
            tempvar.phoneNumber = x.phoneNumber;
            tempvar.projectId = this.projectId ? this.projectId : tempvar.projectId;
            tempvar.userId = x.userId;
            tempvar.id = 0;
            this.clientContactDropdown.push(tempvar);
        })
        this.clientContactApprovers = [];
        this.flag = 1;
        this.clientStyle = true;
        let div = document.getElementById("tableDiv-client");
        if (div != null) div.style.display = "none";
        this.mangerSelecteShow = false;

    }

    removeSelectedClient() {
        this.clientsdata = null;
        this.clientContactDropdown = [];
        this.clientsdatabinded = null;
    }

    onIncrement(i: number, event: Event): void {
        event.stopPropagation();

        if (this.listMember[i].weeklyMinHrs >= this.maxDailyHours) {
            return;
        }
        if (this.listMember[i].weeklyMinHrs === this.listMember[i].weeklyMaxHrs &&
            this.listMember[i].weeklyMaxHrs < this.maxDailyHours) {
            this.listMember[i].weeklyMaxHrs += 1;
        }
        this.listMember[i].weeklyMinHrs += 1;

    }
    onDecrement(i: number): void {
        event.stopPropagation();

        if (this.listMember[i].weeklyMinHrs === 0) return;
        this.listMember[i].weeklyMinHrs -= 1;
        if (this.listMember[i].weeklyMinHrs < 0) {
            this.listMember[i].weeklyMinHrs = 0;
        }
    }

    onIncrementMaxHrs(i: number): void {
        if (this.listMember[i].weeklyMaxHrs >= this.maxDailyHours) {
            return;
        }
        this.listMember[i].weeklyMaxHrs += 1;
        this.updateProjectHoursValidation();
    }

    onIncrementMinHrs(i: number): void {
        if (this.listMember[i].weeklyMinHrs >= this.maxDailyHours) {
            return;
        }
        this.listMember[i].weeklyMinHrs += 1;
    }

    onDecrement1(i: number): void {

        if (this.listMember[i].weeklyMaxHrs === 0) return;
        if (this.listMember[i].weeklyMinHrs === this.listMember[i].weeklyMaxHrs) {
            this.listMember[i].weeklyMinHrs -= 1;
        }
        this.listMember[i].weeklyMaxHrs -= 1;
        if (this.listMember[i].weeklyMaxHrs < 0) {
            this.listMember[i].weeklyMaxHrs = 0;
        }
        this.updateProjectHoursValidation();
    }

    displayCounter(count) {
        this.imagePath = count;
        count = '';
    }

    deletePicture() {
        this.imagePath = '';
    }

    deletelist(record, index) {
        if (record.id !== null) {
            this.listMember.splice(index, 1);
            let list = new ProjectTeamGetAllDto();
            (list.id = record.id), (list.userId = record.userId), (list.isDeleted = true);
            this.removeUserById(record.userId)
            this.deleteMemberList.push(list);
            if (this.listMember.length === 0) {
                this.teamMemberFlagId = null;
                this.teamMemberStyle = true;
            }
        } else {
            this.listMember.splice(index, 1);
            this.selectedMembers.pop();
            if (index === 0) {
                this.teamMemberFlagId = null;
                this.teamMemberStyle = true;
            }
        }
        this.selectedTeamDropdown = this.listMember.filter(x => x.userId != record.userId);
        this.projectManager = this.projectManager.filter(x => x.id != record.userId);
        if (this.programManager != null && this.programManager.id == record.userId) this.programManager = null;
        this.getfilteredUsers();
    }
    sttring = ["One", "Two", "Three", "Four", "Five"];

removeUserById(approverId: number): void {
    // Iterate over the levels
    if(this.hasMoreThanOneApprover()) {
    for (let i = 0; i <= 5 - 1; i++) {
        let level = this.sttring[i];
        let idKey = `approverIdLevel${level}` as keyof typeof ProjectTimeOffCreateOrEditDto;
        let levelKey = `approvalWindow${level}` as keyof typeof ProjectTimeOffCreateOrEditDto;
        let approvalWindowInFive = `approvalWindowIn${level}` as keyof typeof ProjectTimeOffCreateOrEditDto;
        let approverLevelfir = `approverLevel${level}` as keyof typeof ProjectTimeOffCreateOrEditDto;
        // Check if the approver is at the current level
        if (this.editProject.projectTimeOff[idKey] === approverId) 
        {
            // Loop through remaining levels and shift them up
            for (let j = i; j <= 5 - 2; j++) {
                let nextLevel = this.sttring[j + 1];
                let nextIdKey = `approverIdLevel${nextLevel}` as keyof typeof ProjectTimeOffCreateOrEditDto;
                let nextLevelKey = `approvalWindow${nextLevel}` as keyof typeof ProjectTimeOffCreateOrEditDto;
                let nextApprovalWindowInFive = `approvalWindowIn${nextLevel}` as keyof typeof ProjectTimeOffCreateOrEditDto;
                let approverLevel = `approverLevel${nextLevel}` as keyof typeof ProjectTimeOffCreateOrEditDto;
                // Move next level's values to current level
                this.editProject.projectTimeOff[idKey] = this.editProject.projectTimeOff[nextIdKey];
                this.editProject.projectTimeOff[levelKey] = this.editProject.projectTimeOff[levelKey];
                this.editProject.projectTimeOff[approvalWindowInFive] = this.editProject.projectTimeOff[approvalWindowInFive];
                this.editProject.projectTimeOff[approverLevelfir] = this.editProject.projectTimeOff[approverLevel];
                // Update keys for next iteration
                idKey = nextIdKey;
                levelKey = nextLevelKey;
                approvalWindowInFive = nextApprovalWindowInFive;
                approverLevelfir =approverLevel;
                
            }
            this.projectTimeOffApprovalComponentInstace.projectTimeOffEdit = this.editProject.projectTimeOff;
            this.projectTimeOffApprovalComponentInstace.dataChanged = false;
            this.projectTimeOffApprovalComponentInstace.ngOnChanges();
            this.projectTimeOffApprovalComponentInstace.emitdata();
        }
    }
    }
}

hasMoreThanOneApprover(): boolean {
    let approversCount = 0;
    for (let i = 0; i <= 5 - 1; i++) {
        let level = this.sttring[i];
        let idKey = `approverIdLevel${level}` as keyof typeof ProjectTimeOffCreateOrEditDto;
        if (this.editProject != null && this.editProject.projectTimeOff[idKey]) {
            approversCount++;
        }
    }
    return approversCount > 1;
}

    SelectionTeam(SelectedTeam: ProjectTeamGetAllDto[]) {

        if (SelectedTeam.length > 0) {
            for (let i = 0; i < SelectedTeam.length; i++) {
                let flag = true;
                for (let j = i + 1; j < SelectedTeam.length; j++) {
                    if (SelectedTeam[i].userId === SelectedTeam[j].userId) {
                        flag = false;
                        break;
                    }
                }
                if (flag) {
                    let flag2 = true;
                    this.listMember.forEach(member => {
                        if (member.userId === SelectedTeam[i].userId) {
                            flag2 = false;
                        }
                    })
                    if (flag2) {
                        this.listMember.push(SelectedTeam[i]);
                    }
                }
            }
            this.teamMemberFlagId = 1;
        }
        this.updateProjectHoursValidation();
    }

    addProgramManagerMember(SelectedMem: UserListDto) {
        this.programManager = this.ProgramManagerUsers.find(x => x.id == SelectedMem.id);
        this.listMember = this.listMember.filter(x => x.projectRole != 'Program Manager');
        this.selectedTeamDropdown = [...this.listMember];
        if (this.listMember.find(x => x.userId === SelectedMem.id)) return;
        this.listMember.forEach(x => {
            if (SelectedMem.id == x.userId) return;
        })
        let member = new ProjectTeamGetAllDto();
        member.userId = SelectedMem.id;
        member.name = SelectedMem.name;
        member.projectRole = "Program Manager";
        member.surname = SelectedMem.surname;
        member.emailAddress = SelectedMem.emailAddress;
        member.profileImage = SelectedMem.profileImage;
        member.weeklyMinHrs = 0;
        member.weeklyMaxHrs = 0;
        if (SelectedMem.companyJoinDate != undefined) {

            this.tempDate = new Date(SelectedMem.companyJoinDate.toString());
        }
        else {
            this.tempDate = new Date(SelectedMem.creationTime.toString());
        }
        // Set member start and end dates to project dates
        member.startDate = this.startdate;
        member.endDate = this.enddate;
        this.listMember.push(member);
        this.getfilteredUsers();
        this.updateProjectHoursValidation();
    }

    addProjectManagerMember(SelectedMem: UserListDto) {
        if (this.listMember.find(x => x.userId === SelectedMem.id)) return;
        this.listMember.forEach(x => {
            if (SelectedMem.id == x.userId) return;
        })
        let member = new ProjectTeamGetAllDto();
        member.userId = SelectedMem.id;
        member.name = SelectedMem.name;
        member.projectRole = "Project Manager";
        member.surname = SelectedMem.surname;
        member.emailAddress = SelectedMem.emailAddress;
        member.profileImage = SelectedMem.profileImage;
        member.weeklyMinHrs = 0;
        member.weeklyMaxHrs = 0;

        if (SelectedMem.companyJoinDate != undefined) {

            this.tempDate = new Date(SelectedMem.companyJoinDate.toString());
        }
        else {
            this.tempDate = new Date(SelectedMem.creationTime.toString());
        }

        member.joiningDate = this.tempDate;
        // Set member start and end dates to project dates
        member.startDate = this.startdate;
        member.endDate = this.enddate;
        this.listMember.push(member);
        this.addTeamMember(member);
        this.getfilteredUsers();
        this.updateProjectHoursValidation();
    }
    selectedCheckboxIndex: any[] = []; // Initialize the property with a default value

    toggleSelection(item: any): void {
        if (this.isSelected(item)) {
            // Item is already selected, remove it from the array
            const index = this.selectedCheckboxIndex.indexOf(item);
            this.selectedCheckboxIndex.splice(index, 1);
        } else {
            // Item is not selected, add it to the array
            this.selectedCheckboxIndex.push(item);
        }
    }

    isSelected(item: any): boolean {
        return this.selectedCheckboxIndex.includes(item);
    }

    onDropdownOpen(): void {
        // Manually update the ngModel binding to reflect the selected checkboxes
        this.selectedCheckboxIndex = [...this.selectedCheckboxIndex];
    }

    stopPropagation(event: Event): void {
        event.stopPropagation();
    }
    addTeamMember(SelectedMem: ProjectTeamGetAllDto) {
        if (this.listMember.find(x => x.userId === SelectedMem.userId)) return;
        this.listMember.forEach(x => {
            if (SelectedMem.userId == x.userId) return;
        })
        SelectedMem.projectRole = this.ProgramManagerUsers.find(x => x.id == SelectedMem.userId) ? "Program Manager" : SelectedMem.projectRole;
        SelectedMem.projectRole = this.ProjectManagerUsers.find(x => x.id == SelectedMem.userId) ? "Project Manager" : SelectedMem.projectRole;
        // Set member start and end dates to project dates if not already set
        if (!SelectedMem.startDate) {
            SelectedMem.startDate = this.startdate;
        }
        if (!SelectedMem.endDate) {
            SelectedMem.endDate = this.enddate;
        }
        this.listMember.push(SelectedMem);
        this.getfilteredUsers();
        this.updateProjectHoursValidation();
    }
    onProjectManagerMemberChanges(event) {
        let userData = event?.value
        this.listMember = this.listMember.filter(x => x.userId != userData.id);
        this.selectedTeamDropdown = [...this.listMember];
        this.getfilteredUsers();
        this.updateProjectHoursValidation();
    }

    removeTeamMember(event: any) {
        let SelectedMem = event.value;

        if (this.listMember.find(x => x.userId === SelectedMem.userId)) {
            this.listMember = this.listMember.filter(x => x.userId != SelectedMem.userId);

        }
        this.selectedTeamDropdown = this.listMember.filter(x => x.userId != SelectedMem.userId);
        this.projectManager = this.projectManager.filter(x => x.id != SelectedMem.userId);
        if (this.programManager != null && this.programManager.id == SelectedMem.userId) this.programManager = null;
        this.getfilteredUsers();
        this.updateProjectHoursValidation();
    }
    isUserIsmanager(userId: number) {
        if (this.programManager && (this.programManager.id == userId)) return true;
        let userIsProjectManager = this.ProjectManagerUsers.find(x => x.id == userId) || this.ProgramManagerUsers.find(x => x.id == userId);
        if (userIsProjectManager) return true;

        return false;
    }

    hideProdService(record: TenantProductServiceGetAllDto, index: number) {
        this.selectedProductServiceRecords.splice(index, 1);
        this.selectedProductServiceRecords = this.selectedProductServiceRecords.filter(x => x.id != record.id);
        this.serviceList = this.serviceList.filter(x => x.id != record.id);
    }

    addService(event: TenantProductServiceGetAllDto) {

        this.selectedProductServiceRecords
        let service = new TenantProductServiceDto();
        service.tenantProductServiceId = event.id;
        service.productServiceTypeId = event.productServiceTypeId;
        service.name = event.name;
        service.projectBillingServiceRate = event.rate;
        service.productServiceImage = event.productServiceImage;
        service.id = event.id;
        this.serviceList.push(service);

    }
    removeService(event: any) {

        let serv = event.value
        this.serviceList = this.serviceList.filter(x => x.tenantProductServiceId != serv.id);
    }

    hideAccounts() {
        let div = document.getElementById("tableDiv3");
        div.style.display = "none";
        this.mangerSelecteShow = true;
    }

    setProjectType(type: number) {
        this.projectType = type;
        this.project.projectType = type;
    }

    accordianOpen(id: number) {
        for (let i = 0; i < 5; i++) {
            if (this.visited[i] === 1) {

                document.getElementById("collapse" + this.number[i]).className = "collapsing";
                document.getElementById("heading" + this.number[i]).className = "white";
                this.visited[i] = 0;
                if (id === i) {
                    break;
                }

            }
            if (id === i) {

                document.getElementById("collapse" + this.number[i]).className = "show";
                document.getElementById("heading" + this.number[i]).className = "accordion-selected-bg";
                this.visited[i] = 1;

            }
        }
    }

    deleteIntegrationSelection(e) {
        this.integrationSigleSelectedData.splice(e, 1);
    }

    selectedIntegration(event) {
        if (!this.integrationSigleSelectedData.find(x => x.id == event?.id)) this.integrationSigleSelectedData.push(event);
        this.CloseAssignedClientDropdown("tableDiv3");
    }

    // remove
    closeLevel1Dropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }
    closeLevel2Dropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }

    closeLevel3Dropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }

    closeLevel4Dropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }

    closeLevel5Dropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }
    closeClientApprovalDropdown(tableDiv) {
        let div = document.getElementById(tableDiv);
        if (div.style.display !== "none") {
            div.style.display = "none";
        }
    }

    onClientApprovalDropDwnSelected() {
        this.filterTextClientApproval = "";
        let div = document.getElementById("tableDiv-ClientApproval");
        div.style.display = "none";
        let x = document.getElementById("SelectscrollpersonOfAuthority2DropdownButton");
        if (x) x.classList.toggle("up-arrow");
    }

    // removelines onLevel12345DropDwnSelected
    onLevel1DropDwnSelected() {
        this.filterText1 = "";
        let div = document.getElementById("tableDiv-level1");
        div.style.display = "none";
        let x = document.getElementById("SelectscrollpersonOfAuthority2DropdownButton");
        if (x) x.classList.toggle("up-arrow");
        if (this.projectTimesheet?.approverLevelOne != null) {
            this.userRecords2.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelOne.id) {
                    this.userRecords2.splice(i, 1);
                }
            })
            this.userRecords3.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelOne.id) {
                    this.userRecords3.splice(i, 1);
                }
            })
            this.userRecords4.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelOne.id) {
                    this.userRecords4.splice(i, 1);
                }
            })
            this.userRecords5.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelOne.id) {
                    this.userRecords5.splice(i, 1);
                }
            })
        };
    }

    onLevel2DropDwnSelected() {
        if (this.projectTimesheet.approverLevelTwo.id === this.projectTimesheet.approverLevelOne.id) {
            this.projectTimesheet.approverLevelTwo = undefined;
            this._messageService.error(this.l("Aprroverisalreadyselected"));
            return;
        }
        this.filterText2 = "";
        let div = document.getElementById("tableDiv-level2");
        div.style.display = "none";
        let x = document.getElementById("SelectscrollpersonOfAuthority2DropdownButton");
        if (x) x.classList.toggle("up-arrow");
        if (this.projectTimesheet?.approverLevelTwo != null) {
            this.userRecords3.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelTwo.id) {
                    this.userRecords3.splice(i, 1);
                }
            })
            this.userRecords4.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelTwo.id) {
                    this.userRecords4.splice(i, 1);
                }
            })
            this.userRecords5.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelTwo.id) {
                    this.userRecords5.splice(i, 1);
                }
            })

        };
    }

    onLevel3DropDwnSelected() {
        if (this.projectTimesheet.approverLevelTwo.id === this.projectTimesheet.approverLevelThree.id || this.projectTimesheet.approverLevelOne.id === this.projectTimesheet.approverLevelThree.id) {
            this.projectTimesheet.approverLevelThree = undefined;
            this._messageService.error(this.l("Aprroverisalreadyselected"));
            return;
        }
        this.filterText3 = "";
        let div = document.getElementById("tableDiv-level3");
        div.style.display = "none";
        let x = document.getElementById("SelectscrollpersonOfAuthority2DropdownButton");
        if (x) x.classList.toggle("up-arrow");
        if (this.projectTimesheet?.approverLevelThree != null) {
            this.userRecords4.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelThree.id) {
                    this.userRecords4.splice(i, 1);
                }
            })
            this.userRecords5.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelThree.id) {
                    this.userRecords5.splice(i, 1);
                }
            })
        };
        this.level4disabled = false;
        this.addMoreLevel = false;
    }

    onLevel4DropDwnSelected() {
        if (this.projectTimesheet.approverLevelFour.id === this.projectTimesheet.approverLevelThree.id
            || this.projectTimesheet.approverLevelFour.id === this.projectTimesheet.approverLevelTwo.id
            || this.projectTimesheet.approverLevelFour.id === this.projectTimesheet.approverLevelOne.id) {
            this.projectTimesheet.approverLevelFour = undefined;
            this._messageService.error(this.l("Aprroverisalreadyselected"));
            return;
        }
        this.filterText4 = "";
        let div = document.getElementById("tableDiv-level4");
        div.style.display = "none";
        let x = document.getElementById("SelectscrollpersonOfAuthority2DropdownButton");
        if (x) x.classList.toggle("up-arrow");
        if (this.projectTimesheet?.approverLevelFour != null) {
            this.userRecords5.forEach((user, i) => {
                if (user.id == this.projectTimesheet.approverLevelFour.id) {
                    this.userRecords5.splice(i, 1);
                }
            })
        };
        this.addMoreLevel = false;
    }

    onLevel5DropDwnSelected() {
        if (this.projectTimesheet.approverLevelFour.id === this.projectTimesheet.approverLevelFive.id
            || this.projectTimesheet.approverLevelThree.id === this.projectTimesheet.approverLevelFive.id
            || this.projectTimesheet.approverLevelTwo.id === this.projectTimesheet.approverLevelFive.id
            || this.projectTimesheet.approverLevelOne.id === this.projectTimesheet.approverLevelFive.id) {
            this.projectTimesheet.approverLevelFive = undefined;
            this._messageService.error(this.l("Aprroverisalreadyselected"));
            return;
        }
        this.filterText5 = "";
        let div = document.getElementById("tableDiv-level5");
        div.style.display = "none";
        let x = document.getElementById("SelectscrollpersonOfAuthority2DropdownButton");
        if (x) x.classList.toggle("up-arrow");
    }

    // removelines
    getTimesheetRecords(serachboxnum: number) {
        let filterString = "";
        if (serachboxnum === 1) {
            filterString = this.filterText1;
        } else if (serachboxnum === 2) {
            filterString = this.filterText2
        } else if (serachboxnum === 3) {
            filterString = this.filterText3
        } else if (serachboxnum === 4) {
            filterString = this.filterText4
        } else if (serachboxnum === 5) {
            filterString = this.filterText5
        }
        this._userServiceProxy
            .getUsers(
                filterString,
                undefined,
                this.role !== "" ? parseInt(this.role) : undefined,
                undefined,
                this.onlyLockedUsers,
                false,
                undefined,
                undefined,
                undefined,
                undefined
            )
            .subscribe(result => {
                if (serachboxnum === 0) {
                    this.userRecords = [];
                    this.userRecords2 = [];
                    this.userRecords3 = [];
                    this.userRecords4 = [];
                    this.userRecords5 = [];
                }
                if (serachboxnum === 1) this.userRecords = [];
                if (serachboxnum === 2) this.userRecords2 = [];
                if (serachboxnum === 3) this.userRecords3 = [];
                if (serachboxnum === 4) this.userRecords4 = [];
                if (serachboxnum === 5) this.userRecords5 = [];

                result?.items?.forEach(x => {
                    if (x.profileImage === '' || x.profileImage === 'undefined' || x.profileImage === null) {
                        x.profileImage = 'assets/common/images/default-profile-picture1.svg';
                    }
                    if (serachboxnum === 0 || serachboxnum === 1) this.userRecords.push(x);
                    if (serachboxnum === 0 || serachboxnum === 2) this.userRecords2.push(x);
                    if (serachboxnum === 0 || serachboxnum === 3) this.userRecords3.push(x);
                    if (serachboxnum === 0 || serachboxnum === 4) this.userRecords4.push(x);
                    if (serachboxnum === 0 || serachboxnum === 5) this.userRecords5.push(x);

                });
                filterString = "";
            });
    }
    getClientsContact() {

    }

    //getonlyselected team members && managers in dropdown timesheet approvers
    getfilteredUsers() {

        this.filteredUsers = [];
        if (this.programManager != null) this.filteredUsers.push(this.programManager);
        this.projectManager.forEach(x => this.filteredUsers.push(x));
        this.userRecords.forEach(x => {
            this.listMember.forEach(y => {
                if (y.userId === x.id) this.filteredUsers.push(x);
            })
        })
        this.filteredUsers = _.uniqBy(this.filteredUsers,
            (user) => { return user.id; }
        );
        this.filterLeaveAndTSApprovalList()
    }

    addLevels() {
        this.TimesheetApproverLevelShow++;
        if (this.TimesheetApproverLevelShow === 0) {
            this.LevelShow1 = true;
            this.LevelShow2 = false;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 1) {
            this.LevelShow1 = false;
            this.LevelShow2 = true;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 2) {
            this.LevelShow2 = false;
            this.LevelShow1 = false;
            this.LevelShow3 = true;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 3) {
            this.LevelShow3 = false;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow4 = true;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 4) {
            this.LevelShow4 = false;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow3 = false;
            this.LevelShow5 = true;
        }
        this.addMoreLevel = true;
        if (this.TimesheetApproverLevelShow == 4) {
            this.isLevelCount5 = true;
        }
    }

    removeLevelData(id: number) {
        if (id == 2) {
            this.approverDetailLevel2 = null;
        }
        else if (id == 3) {
            this.approverDetailLevel3 = null;

        }
        else if (id == 4) {
            this.approverDetailLevel4 = null;
        }

        else if (id == 5) {
            this.approverDetailLevel5 = null;
        }

    }

    removeLevel() {

        this.approverDetailLevel2 = null;
        if (this.TimesheetApproverLevelShow == 1) {
            this.projectTimesheet.approvalWindowInTwo = null;
            this.projectTimesheet.approvalWindowTwo = null;
            this.projectTimesheet.approverLevelTwo = null;

        } else if (this.TimesheetApproverLevelShow == 2) {
            this.projectTimesheet.approvalWindowInThree = null;
            this.projectTimesheet.approvalWindowThree = null;
            this.projectTimesheet.approverLevelThree = null;
        } else if (this.TimesheetApproverLevelShow == 3) {
            this.projectTimesheet.approvalWindowInFour = null;
            this.projectTimesheet.approvalWindowFour = null;
            this.projectTimesheet.approverLevelFour = null;
        } else if (this.TimesheetApproverLevelShow == 4) {
            this.projectTimesheet.approvalWindowInFive = null;
            this.projectTimesheet.approvalWindowFive = null;
            this.projectTimesheet.approverLevelFive = null;
        }
        if (this.TimesheetApproverLevelShow === 1) {
            this.LevelShow1 = true;
            this.LevelShow2 = false;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 2) {
            this.LevelShow2 = true;
            this.LevelShow1 = false;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 3) {
            this.LevelShow3 = true;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 4) {
            this.LevelShow4 = true;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow3 = false;
            this.LevelShow5 = false;
        }
        if (this.TimesheetApproverLevelShow === 5) {
            this.LevelShow5 = true;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
        }
        this.TimesheetApproverLevelShow--;
        this.isLevelCount5 = false;
    }

    ClientAprroversSelection(data: ProjectClientApproversDto) {

        let isClientApproverAlreadyAssign = false;
        this.clientContactApprovers.forEach((x, i) => {

            if (x.clientContactId == data.clientContactId) {
                isClientApproverAlreadyAssign = true;

                return;
            }
        });
        if (!isClientApproverAlreadyAssign) {
            this.clientContactApprovers.push(data);
        }
        ;
    }

    //taking index to unselect clientcontact for client approver
    ClientAprroversUnselection(data: ClientContactDto, index: number) {
        this.clientContactApprovers.splice(index, 1);
    }

    projectTimeoffselection(data: ProjectTimeOffCreateOrEditDto) {
        this.projectTimeOffdata = data;
        this.showIsTimeOffLevel1Error = false;
    }

    showValidation(data: any) {
        if (this.editProject?.projectTimeOff) {
            this.editProject.projectTimeOff.approverIdLevelOne = data.approver
            this.editProject.projectTimeOff.approvalWindowOne = data.approvalWindow;
            this.editProject.projectTimeOff.approvalWindowInOne = data.windowType;
        }
    }

    getFullname(name: string, lastname: string) {
        return name + " " + lastname;
    }

    getLocalJsDate(date: DateTime): Date {
        if (!date) return;
        let jsDate = new Date(
            `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day
            }T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`
        );
        ;
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }

    setZeroTimeForLocalDate(date: Date): Date {

        date.setHours(0, 0, 0, 0);

        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);

    }

    isDailyHoursExceedingLimit(min: number, max: number): boolean {
        return (min != null && min > this.maxDailyHours) || (max != null && max > this.maxDailyHours);
    }

    isMinMaxOrderInvalid(min: number, max: number): boolean {
        return min != null && max != null && min > max;
    }

    isMinMaxValid(min: number, max: number) {
        if (this.isDailyHoursExceedingLimit(min, max)) {
            return false;
        }
        if (this.isMinMaxOrderInvalid(min, max)) {
            return false;
        }
        return true;
    }

    onDailyMinHrsChange(member: ProjectTeamGetAllDto, value: number): void {
        const hours = Number(value);
        if (isNaN(hours)) {
            return;
        }
        if (hours > this.maxDailyHours) {
            member.weeklyMinHrs = this.maxDailyHours;
        } else if (hours < 0) {
            member.weeklyMinHrs = 0;
        }
    }

    onDailyMaxHrsChange(member: ProjectTeamGetAllDto, value: number): void {
        const hours = Number(value);
        if (isNaN(hours)) {
            return;
        }
        if (hours > this.maxDailyHours) {
            member.weeklyMaxHrs = this.maxDailyHours;
        } else if (hours < 0) {
            member.weeklyMaxHrs = 0;
        }
        this.updateProjectHoursValidation();
    }

    onProjectHoursChange(): void {
        this.updateProjectHoursValidation();
    }

    getTeamHoursValidationMessage(): string | null {
        for (const member of this.listMember) {
            if (member.weeklyMinHrs > this.maxDailyHours || member.weeklyMaxHrs > this.maxDailyHours) {
                return 'Daily hours cannot exceed 24.';
            }
            if (member.weeklyMaxHrs < member.weeklyMinHrs) {
                return 'Min Hrs should be less than or equal to Max Hrs';
            }
        }
        return null;
    }

    AppoverLevelShowOnEdit(TimesheetApprovers: ProjectTimeSheetGetAllDto) {
        if (TimesheetApprovers.approverLevelTwo != null) {
            this.TimesheetApproverLevelShow = 1;
            this.LevelShow1 = false;
            this.LevelShow2 = true;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (TimesheetApprovers.approverLevelThree != null) {
            this.TimesheetApproverLevelShow = 2;
            this.LevelShow2 = false;
            this.LevelShow1 = false;
            this.LevelShow3 = true;
            this.LevelShow4 = false;
            this.LevelShow5 = false;
        }
        if (TimesheetApprovers.approverLevelFour != null) {
            this.TimesheetApproverLevelShow = 3;
            this.LevelShow3 = false;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow4 = true;
            this.LevelShow5 = false;
        }
        if (TimesheetApprovers.approverLevelFive != null) {
            this.TimesheetApproverLevelShow = 4;
            this.LevelShow5 = true;
            this.LevelShow1 = false;
            this.LevelShow2 = false;
            this.LevelShow3 = false;
            this.LevelShow4 = false;
        }
    }

    getProjectDurationInDays(): number {
        if (!this.startdate || !this.enddate) {
            return 0;
        }

        const start = this.toDateOnly(this.startdate);
        const end = this.toDateOnly(this.enddate);
        const days = (end.getTime() - start.getTime()) / (1000 * 3600 * 24);

        return days > 0 ? days : 0;
    }

    calculateTotalAllocatedTeamMaxHours(projectTeam: ProjectTeamGetAllDto[]): number {
        const projectDays = this.getProjectDurationInDays();
        if (!projectDays || !projectTeam?.length) {
            return 0;
        }

        const totalDailyMaxHrs = projectTeam.reduce((sum, member) => sum + (Number(member.weeklyMaxHrs) || 0), 0);
        return totalDailyMaxHrs * projectDays;
    }

    updateProjectHoursValidation(): void {
        this.projectTeamTotalWorkHrs = Math.round(this.calculateTotalAllocatedTeamMaxHours(this.listMember));

        if (this.project.hourlyBudget == null || this.project.hourlyBudget === undefined) {
            this.projDurationValid = true;
            return;
        }

        this.projDurationValid = this.project.hourlyBudget >= this.projectTeamTotalWorkHrs;
    }

    getProjectHoursValidationMessage(): string | null {
        if (this.projDurationValid || this.project.hourlyBudget == null || this.project.hourlyBudget === undefined) {
            return null;
        }

        return `Total hours (${this.project.hourlyBudget}) cannot be less than the total allocated team hours (${this.projectTeamTotalWorkHrs}).`;
    }

    ProjectHoursValidationIsvalid(projectTeam: ProjectTeamGetAllDto[], projectHours: number) {
        if (projectHours == null || projectHours == undefined) {
            return true;
        }

        this.projectTeamTotalWorkHrs = Math.round(this.calculateTotalAllocatedTeamMaxHours(projectTeam));
        this.projDurationValid = projectHours >= this.projectTeamTotalWorkHrs;

        return this.projDurationValid;
    }

    TeamMinMaxHoursValidationIsvalid(projectTeam: ProjectTeamGetAllDto[], projectHours: number) {
        let isValid = true;
        projectTeam.forEach(x => {
            if (x.weeklyMaxHrs < x.weeklyMinHrs) isValid = false;
            if (x.weeklyMinHrs > this.maxDailyHours || x.weeklyMaxHrs > this.maxDailyHours) isValid = false;
        });

        return isValid;
    }

    defaultValuesForTimesheetDropdown() {
        this.projectTimesheet.submissionFrequency = 0 as any;
        this.projectTimesheet.approvalWindowInFive = 1;
        this.projectTimesheet.approvalWindowInFour = 1;
        this.projectTimesheet.approvalWindowInThree = 1;
        this.projectTimesheet.approvalWindowInTwo = 1;
        this.projectTimesheet.approvalWindowInOne = 1;
        this.projectTimesheet.taskAccountabilityInMinutes = 120;
        this.projectTimesheet.notificationAlertInMinutes = 30;
    }

    removeProjectManager(i: number, pm: UserListDto) {

        this.projectManager = this.projectManager.filter(x => !(pm.id === x.id));
        this.getfilteredUsers();
    }

    keyPressAlphaNumeric(event) {
        var inp = String.fromCharCode(event.keyCode);
        if (/[a-zA-Z0-9\w\s]/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }
    keyPressAvoidNegative(event) {
        var inp = String.fromCharCode(event.keyCode);
        if (/[0-9]/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    showSidePanel() {
        this.isSidebarOpen = true;
        this.isSidePanel = true;
    }
    confirmAndCloseSidePanel() {

        this.appModalPopup.show(2);
    }
    closeSidePanel() {
        if (this.devProjectName === " " || this.personalAccessToken === " " || this.personalAccessToken === " ") {
            this.toastr.error("Field is empty")
        }
        this.project.devProjectName = this.devProjectName;
        this.personalAccessToken = this.personalAccessToken;
        this.projectURL = this.projectURL;

        this.isSidebarOpen = false;

        this.isSidePanel = false;

    }
    closeSidebar() {

        this.isSidebarOpen = false;

        this.isSidePanel = false;

    }

    projectTimesheetValid() {
        if (!this.projectTimesheet.approverLevelOne) return false;
        if ((!this.projectTimesheet.approverLevelTwo || this.approverDetailLevel2.WindowEnum == undefined || this.approverDetailLevel2.WindowNum == undefined || this.approverDetailLevel2.user == undefined) && this.TimesheetApproverLevelShow >= 1) return false;
        if ((!this.projectTimesheet.approverLevelThree || this.approverDetailLevel3.WindowEnum == undefined || this.approverDetailLevel3.WindowNum == undefined || this.approverDetailLevel3.user == undefined) && this.TimesheetApproverLevelShow >= 2) return false;
        if ((!this.projectTimesheet.approverLevelFour || this.approverDetailLevel4.WindowEnum == undefined || this.approverDetailLevel4.WindowNum == undefined || this.approverDetailLevel4.user == undefined) && this.TimesheetApproverLevelShow >= 3) return false;
        if ((!this.projectTimesheet.approverLevelFive || this.approverDetailLevel5.WindowEnum == undefined || this.approverDetailLevel5.WindowNum == undefined || this.approverDetailLevel5.user == undefined) && this.TimesheetApproverLevelShow >= 4) return false;

        return true;
    }

    wantsTofillTimeOffApprover() {
        if (this.projectId) {
            if (this.editProject.projectTimeOff) {
                this.showIsTimeOffLevel1Error = false;
                return true;
            }
            else {
                if (this.projectTimeOffdata?.approverIdLevelOne) return true;
                return false;
            }
        }
    }

    wantsTofillTimesheetApprover() {
        if (this.projectTimesheet.approverLevelOne || this.projectTimesheet.approverLevelTwo || this.projectTimesheet.approverLevelThree) {
            this.dataSubmitted = true;
            return true;
        }
        else {
            return false;
        }
    }

    // filter timesheet approval dropdown users data
    timeSheetApprovarDropdown() {
        let dropDownTsApprovers = [];
        dropDownTsApprovers = this.filteredUsers.filter(x => x.id != this.projectTimesheet.approverLevelOne?.id
            && x.id != this.projectTimesheet.approverLevelTwo?.id
            && x.id != this.projectTimesheet.approverLevelThree?.id
            && x.id != this.projectTimesheet.approverLevelFour?.id
            && x.id != this.projectTimesheet.approverLevelFive?.id);

        return dropDownTsApprovers;
    }

    // returning timesheet submission freq name
    requiredHoursByTimesheet() {
        if (this.projectTimesheet?.submissionFrequency === undefined || this.projectTimesheet?.submissionFrequency === null) return "None";
        let name = this.TimesheetFreqData.filter(x => x.id == this.projectTimesheet.submissionFrequency).map(x => x.name);
        return name[0];
    }

    //Timesheet submission freq change min abd max hrs
    changeTSfreq() {
        this.listMember.forEach(x => {
            x.weeklyMinHrs = undefined;
            x.weeklyMaxHrs = undefined;
        })
    }

    NameVerify(projectName: string, projectId?: number, isEdit?: boolean) {
        this.isOnlySpaceInString = projectName.trim() === ''
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this._projectServiceProxy.checkDuplicateProject(projectName, projectId, isEdit).subscribe((result) => {
                if (result == true) {
                    this.checkProjectDuplicate = true;
                } else {
                    this.checkProjectDuplicate = false;
                }
            });
        }, 1000);

    }
    checkUncheck(item) {
        item.selected = !item.selected;
    }

    private isEligibleTimesheetApprover(userId: number | undefined): boolean {
        if (!userId) {
            return false;
        }
        return this.filteredUsers.some((user) => user.id === userId);
    }

    private syncTimesheetApproverDetailsFromModel(): void {
        this.approverDetailLevel1.user = this.projectTimesheet.approverLevelOne;
        this.approverDetailLevel2.user = this.projectTimesheet.approverLevelTwo;
        this.approverDetailLevel3.user = this.projectTimesheet.approverLevelThree;
        this.approverDetailLevel4.user = this.projectTimesheet.approverLevelFour;
        this.approverDetailLevel5.user = this.projectTimesheet.approverLevelFive;
    }

    filterLeaveAndTSApprovalList() {
        if (this.approverDetailLevel1?.user?.id && !this.isEligibleTimesheetApprover(this.approverDetailLevel1.user.id)) {
            this.TimeSheetLevel1({
                WindowEnum: this.projectTimesheet.approvalWindowInOne,
                WindowNum: this.projectTimesheet.approvalWindowOne,
                user: null,
            } as ApproverDetail);
        }
        if (this.approverDetailLevel2?.user?.id && !this.isEligibleTimesheetApprover(this.approverDetailLevel2.user.id)) {
            this.TimeSheetLevel2({
                WindowEnum: this.projectTimesheet.approvalWindowInTwo,
                WindowNum: this.projectTimesheet.approvalWindowTwo,
                user: null,
            } as ApproverDetail);
        }
        if (this.approverDetailLevel3?.user?.id && !this.isEligibleTimesheetApprover(this.approverDetailLevel3.user.id)) {
            this.TimeSheetLevel3({
                WindowEnum: this.projectTimesheet.approvalWindowInThree,
                WindowNum: this.projectTimesheet.approvalWindowThree,
                user: null,
            } as ApproverDetail);
        }
        if (this.approverDetailLevel4?.user?.id && !this.isEligibleTimesheetApprover(this.approverDetailLevel4.user.id)) {
            this.TimeSheetLevel4({
                WindowEnum: this.projectTimesheet.approvalWindowInFour,
                WindowNum: this.projectTimesheet.approvalWindowFour,
                user: null,
            } as ApproverDetail);
        }
        if (this.approverDetailLevel5?.user?.id && !this.isEligibleTimesheetApprover(this.approverDetailLevel5.user.id)) {
            this.TimeSheetLevel5({
                WindowEnum: this.projectTimesheet.approvalWindowInFive,
                WindowNum: this.projectTimesheet.approvalWindowFive,
                user: null,
            } as ApproverDetail);
        }

        if (this.editProject?.projectTimeOff?.approverLevelOne) !this.selectedTeamDropdown.find(x => x.userId === this.editProject?.projectTimeOff?.approverLevelOne.id) ? this.editProject.projectTimeOff.approverLevelOne = undefined : undefined;
        if (this.editProject?.projectTimeOff?.approverLevelTwo) !this.selectedTeamDropdown.find(x => x.userId === this.editProject?.projectTimeOff?.approverLevelTwo.id) ? this.editProject.projectTimeOff.approverLevelTwo = undefined : undefined;
        if (this.editProject?.projectTimeOff?.approverLevelThree) !this.selectedTeamDropdown.find(x => x.userId === this.editProject?.projectTimeOff?.approverLevelThree.id) ? this.editProject.projectTimeOff.approverLevelThree = undefined : undefined;
        if (this.editProject?.projectTimeOff?.approverLevelFour) !this.selectedTeamDropdown.find(x => x.userId === this.editProject?.projectTimeOff?.approverLevelFour.id) ? this.editProject.projectTimeOff.approverLevelFour = undefined : undefined;
        if (this.editProject?.projectTimeOff?.approverLevelFive) !this.selectedTeamDropdown.find(x => x.userId === this.editProject?.projectTimeOff?.approverLevelFive.id) ? this.editProject.projectTimeOff.approverLevelFive = undefined : undefined;
    }

    updatevalue(data,event){
        const isEnabled = event?.checked ?? event?.target?.checked ?? event?.target?.value === "1";
        this.projectbillabityAccess = isEnabled ? '1' : '2';
        if (data) {
            data.billabilityStatusAuthority = isEnabled;
        }
        this.project.billabilityStatusAuthority = isEnabled;
        
    }

}
